var _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _g, _g2, _g3, _g4, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFengshuiCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2048,
    height: 2048,
    viewBox: "0 0 900 900",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M 880 450 A 430 430 0 1 1 20 450 A 430 430 0 1 1 880 450 M 642 450 A 192 192 0 1 0 258 450 A 192 192 0 1 0 642 450 Z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "black",
    fill: "none"
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 450,
    y1: 772,
    x2: 450,
    y2: 730,
    stroke: "black",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 533.3397325230117,
    y1: 761.02811606508,
    x2: 522.4693326287058,
    y2: 720.4592313609392,
    stroke: "black",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 611,
    y1: 728.8601800185893,
    x2: 590,
    y2: 692.4871130596428,
    stroke: "black",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 677.6883835420683,
    y1: 677.6883835420683,
    x2: 647.9898987322333,
    y2: 647.9898987322333,
    stroke: "black",
    strokeWidth: 0.6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 728.8601800185893,
    y1: 611,
    x2: 692.4871130596429,
    y2: 590,
    stroke: "black",
    strokeWidth: 0.6
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 761.02811606508,
    y1: 533.3397325230117,
    x2: 720.4592313609392,
    y2: 522.4693326287058,
    stroke: "black",
    strokeWidth: 0.6
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 772,
    y1: 450,
    x2: 730,
    y2: 450,
    stroke: "black",
    strokeWidth: 0.6
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 761.02811606508,
    y1: 366.66026747698834,
    x2: 720.4592313609392,
    y2: 377.53066737129416,
    stroke: "black",
    strokeWidth: 0.6
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 728.8601800185893,
    y1: 289,
    x2: 692.4871130596429,
    y2: 310,
    stroke: "black",
    strokeWidth: 0.6
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 677.6883835420683,
    y1: 222.3116164579317,
    x2: 647.9898987322333,
    y2: 252.01010126776671,
    stroke: "black",
    strokeWidth: 0.6
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 611,
    y1: 171.13981998141077,
    x2: 590,
    y2: 207.5128869403572,
    stroke: "black",
    strokeWidth: 0.6
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 533.3397325230117,
    y1: 138.97188393492002,
    x2: 522.4693326287058,
    y2: 179.5407686390609,
    stroke: "black",
    strokeWidth: 0.6
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 450,
    y1: 128,
    x2: 450,
    y2: 170,
    stroke: "black",
    strokeWidth: 0.6
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 366.6602674769883,
    y1: 138.97188393492002,
    x2: 377.53066737129416,
    y2: 179.5407686390609,
    stroke: "black",
    strokeWidth: 0.6
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 289.0000000000001,
    y1: 171.1398199814107,
    x2: 310.00000000000006,
    y2: 207.51288694035716,
    stroke: "black",
    strokeWidth: 0.6
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 222.3116164579317,
    y1: 222.31161645793168,
    x2: 252.01010126776671,
    y2: 252.0101012677667,
    stroke: "black",
    strokeWidth: 0.6
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 171.1398199814107,
    y1: 289,
    x2: 207.51288694035716,
    y2: 310,
    stroke: "black",
    strokeWidth: 0.6
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 138.97188393492002,
    y1: 366.6602674769882,
    x2: 179.5407686390609,
    y2: 377.5306673712941,
    stroke: "black",
    strokeWidth: 0.6
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 128,
    y1: 449.99999999999994,
    x2: 170,
    y2: 449.99999999999994,
    stroke: "black",
    strokeWidth: 0.6
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 138.97188393491996,
    y1: 533.3397325230115,
    x2: 179.54076863906084,
    y2: 522.4693326287057,
    stroke: "black",
    strokeWidth: 0.6
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 171.13981998141077,
    y1: 611,
    x2: 207.5128869403572,
    y2: 590,
    stroke: "black",
    strokeWidth: 0.6
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 222.31161645793165,
    y1: 677.6883835420683,
    x2: 252.01010126776666,
    y2: 647.9898987322333,
    stroke: "black",
    strokeWidth: 0.6
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 288.9999999999999,
    y1: 728.8601800185892,
    x2: 309.9999999999999,
    y2: 692.4871130596428,
    stroke: "black",
    strokeWidth: 0.6
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 366.66026747698834,
    y1: 761.02811606508,
    x2: 377.5306673712942,
    y2: 720.4592313609392,
    stroke: "black",
    strokeWidth: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outer-rings"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inner-ring-5"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 450,
    y1: 736,
    x2: 450,
    y2: 772,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 524.022246899321,
    y1: 726.2547863186735,
    x2: 533.3397325230117,
    y2: 761.02811606508,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 593,
    y1: 697.6832654823495,
    x2: 611,
    y2: 728.8601800185893,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652.2325394193526,
    y1: 652.2325394193526,
    x2: 677.6883835420683,
    y2: 677.6883835420683,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 697.6832654823495,
    y1: 593,
    x2: 728.8601800185893,
    y2: 611,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 726.2547863186735,
    y1: 524.022246899321,
    x2: 761.02811606508,
    y2: 533.3397325230117,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 736,
    y1: 450,
    x2: 772,
    y2: 450,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 726.2547863186735,
    y1: 375.9777531006791,
    x2: 761.02811606508,
    y2: 366.66026747698834,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 697.6832654823495,
    y1: 307,
    x2: 728.8601800185893,
    y2: 289,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652.2325394193526,
    y1: 247.76746058064742,
    x2: 677.6883835420683,
    y2: 222.3116164579317,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 593,
    y1: 202.31673451765056,
    x2: 611,
    y2: 171.13981998141077,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 524.022246899321,
    y1: 173.74521368132645,
    x2: 533.3397325230117,
    y2: 138.97188393492002,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450,
    y1: 164,
    x2: 450,
    y2: 128,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.977753100679,
    y1: 173.74521368132645,
    x2: 366.6602674769883,
    y2: 138.97188393492002,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.00000000000006,
    y1: 202.31673451765053,
    x2: 289.0000000000001,
    y2: 171.1398199814107,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.76746058064742,
    y1: 247.7674605806474,
    x2: 222.3116164579317,
    y2: 222.31161645793168,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.31673451765053,
    y1: 307,
    x2: 171.1398199814107,
    y2: 289,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.7452136813265,
    y1: 375.977753100679,
    x2: 138.97188393492002,
    y2: 366.6602674769882,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164,
    y1: 449.99999999999994,
    x2: 128,
    y2: 449.99999999999994,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.74521368132645,
    y1: 524.0222468993209,
    x2: 138.97188393491996,
    y2: 533.3397325230115,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.31673451765056,
    y1: 593,
    x2: 171.13981998141077,
    y2: 611,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.76746058064737,
    y1: 652.2325394193526,
    x2: 222.31161645793165,
    y2: 677.6883835420683,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.9999999999999,
    y1: 697.6832654823494,
    x2: 288.9999999999999,
    y2: 728.8601800185892,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.9777531006791,
    y1: 726.2547863186735,
    x2: 366.66026747698834,
    y2: 761.02811606508,
    stroke: "black",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("text", {
    x: 409.2758280273439,
    y: 759.3307967486288,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-352.5, 409.2758280273439, 759.3307967486288)"
  }, "\u51AC\u81F3"), /*#__PURE__*/React.createElement("text", {
    x: 330.60276910209205,
    y: 738.2504141435215,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-337.5, 330.60276910209205, 738.2504141435215)"
  }, "\u5C0F\u5BD2"), /*#__PURE__*/React.createElement("text", {
    x: 260.0664341492791,
    y: 697.5262421708653,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-322.5, 260.0664341492791, 697.5262421708653)"
  }, "\u5927\u5BD2"), /*#__PURE__*/React.createElement("text", {
    x: 202.47375782913463,
    y: 639.9335658507208,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-307.5, 202.47375782913463, 639.9335658507208)"
  }, "\u7ACB\u6625"), /*#__PURE__*/React.createElement("text", {
    x: 161.74958585647846,
    y: 569.3972308979078,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-292.5, 161.74958585647846, 569.3972308979078)"
  }, "\u96E8\u6C34"), /*#__PURE__*/React.createElement("text", {
    x: 140.66920325137113,
    y: 490.724171972656,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-277.5, 140.66920325137113, 490.724171972656)"
  }, "\u60CA\u86F0"), /*#__PURE__*/React.createElement("text", {
    x: 140.6692032513712,
    y: 409.2758280273439,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-262.5, 140.6692032513712, 409.2758280273439)"
  }, "\u6625\u5206"), /*#__PURE__*/React.createElement("text", {
    x: 161.74958585647852,
    y: 330.60276910209194,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-247.5, 161.74958585647852, 330.60276910209194)"
  }, "\u6E05\u660E"), /*#__PURE__*/React.createElement("text", {
    x: 202.4737578291346,
    y: 260.0664341492792,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-232.5, 202.4737578291346, 260.0664341492792)"
  }, "\u8C37\u96E8"), /*#__PURE__*/React.createElement("text", {
    x: 260.0664341492792,
    y: 202.47375782913463,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-217.5, 260.0664341492792, 202.47375782913463)"
  }, "\u7ACB\u590F"), /*#__PURE__*/React.createElement("text", {
    x: 330.602769102092,
    y: 161.74958585647852,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-202.5, 330.602769102092, 161.74958585647852)"
  }, "\u5C0F\u6EE1"), /*#__PURE__*/React.createElement("text", {
    x: 409.27582802734395,
    y: 140.66920325137113,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-187.5, 409.27582802734395, 140.66920325137113)"
  }, "\u8292\u79CD"), /*#__PURE__*/React.createElement("text", {
    x: 490.7241719726561,
    y: 140.6692032513712,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-172.5, 490.7241719726561, 140.6692032513712)"
  }, "\u590F\u81F3"), /*#__PURE__*/React.createElement("text", {
    x: 569.397230897908,
    y: 161.74958585647852,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-157.5, 569.397230897908, 161.74958585647852)"
  }, "\u5C0F\u6691"), /*#__PURE__*/React.createElement("text", {
    x: 639.9335658507208,
    y: 202.47375782913463,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-142.5, 639.9335658507208, 202.47375782913463)"
  }, "\u5927\u6691"), /*#__PURE__*/React.createElement("text", {
    x: 697.5262421708653,
    y: 260.0664341492792,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-127.5, 697.5262421708653, 260.0664341492792)"
  }, "\u7ACB\u79CB"), /*#__PURE__*/React.createElement("text", {
    x: 738.2504141435215,
    y: 330.602769102092,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-112.5, 738.2504141435215, 330.602769102092)"
  }, "\u5904\u6691"), /*#__PURE__*/React.createElement("text", {
    x: 759.3307967486288,
    y: 409.2758280273439,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-97.5, 759.3307967486288, 409.2758280273439)"
  }, "\u767D\u9732"), /*#__PURE__*/React.createElement("text", {
    x: 759.3307967486288,
    y: 490.7241719726561,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-82.5, 759.3307967486288, 490.7241719726561)"
  }, "\u79CB\u5206"), /*#__PURE__*/React.createElement("text", {
    x: 738.2504141435215,
    y: 569.397230897908,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-67.5, 738.2504141435215, 569.397230897908)"
  }, "\u5BD2\u9732"), /*#__PURE__*/React.createElement("text", {
    x: 697.5262421708653,
    y: 639.9335658507208,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-52.5, 697.5262421708653, 639.9335658507208)"
  }, "\u971C\u964D"), /*#__PURE__*/React.createElement("text", {
    x: 639.9335658507208,
    y: 697.5262421708653,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-37.5, 639.9335658507208, 697.5262421708653)"
  }, "\u7ACB\u51AC"), /*#__PURE__*/React.createElement("text", {
    x: 569.397230897908,
    y: 738.2504141435215,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-22.5, 569.397230897908, 738.2504141435215)"
  }, "\u5C0F\u96EA"), /*#__PURE__*/React.createElement("text", {
    x: 490.7241719726561,
    y: 759.3307967486288,
    fontSize: 10,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-7.5, 490.7241719726561, 759.3307967486288)"
  }, "\u5927\u96EA"), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 322,
    fill: "none",
    stroke: "black",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "inner-ring-6"
  }, /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 796,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(0, 450, 796)"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    x: 389.9177305272421,
    y: 790.743482542224,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-350, 389.9177305272421, 790.743482542224)"
  }, "10"), /*#__PURE__*/React.createElement("text", {
    x: 331.6610304093184,
    y: 775.1336467919243,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-340, 331.6610304093184, 775.1336467919243)"
  }, "20"), /*#__PURE__*/React.createElement("text", {
    x: 276.9999999999999,
    y: 749.6447897094157,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-330, 276.9999999999999, 749.6447897094157)"
  }, "30"), /*#__PURE__*/React.createElement("text", {
    x: 227.59548704845733,
    y: 715.0513773191664,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-320, 227.59548704845733, 715.0513773191664)"
  }, "40"), /*#__PURE__*/React.createElement("text", {
    x: 184.94862268083358,
    y: 672.4045129515425,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-310, 184.94862268083358, 672.4045129515425)"
  }, "50"), /*#__PURE__*/React.createElement("text", {
    x: 150.35521029058424,
    y: 623,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-300, 150.35521029058424, 623)"
  }, "60"), /*#__PURE__*/React.createElement("text", {
    x: 124.86635320807568,
    y: 568.3389695906814,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-290, 124.86635320807568, 568.3389695906814)"
  }, "70"), /*#__PURE__*/React.createElement("text", {
    x: 109.256517457776,
    y: 510.08226947275796,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-280, 109.256517457776, 510.08226947275796)"
  }, "80"), /*#__PURE__*/React.createElement("text", {
    x: 104,
    y: 449.99999999999994,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-270, 104, 449.99999999999994)"
  }, "90"), /*#__PURE__*/React.createElement("text", {
    x: 109.256517457776,
    y: 389.91773052724216,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-260, 109.256517457776, 389.91773052724216)"
  }, "100"), /*#__PURE__*/React.createElement("text", {
    x: 124.86635320807574,
    y: 331.6610304093186,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-250, 124.86635320807574, 331.6610304093186)"
  }, "110"), /*#__PURE__*/React.createElement("text", {
    x: 150.35521029058418,
    y: 277,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-240, 150.35521029058418, 277)"
  }, "120"), /*#__PURE__*/React.createElement("text", {
    x: 184.94862268083364,
    y: 227.59548704845733,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-230, 184.94862268083364, 227.59548704845733)"
  }, "130"), /*#__PURE__*/React.createElement("text", {
    x: 227.5954870484574,
    y: 184.94862268083358,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-220, 227.5954870484574, 184.94862268083358)"
  }, "140"), /*#__PURE__*/React.createElement("text", {
    x: 277.0000000000001,
    y: 150.35521029058418,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-210, 277.0000000000001, 150.35521029058418)"
  }, "150"), /*#__PURE__*/React.createElement("text", {
    x: 331.66103040931864,
    y: 124.86635320807568,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-200, 331.66103040931864, 124.86635320807568)"
  }, "160"), /*#__PURE__*/React.createElement("text", {
    x: 389.9177305272421,
    y: 109.256517457776,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-190, 389.9177305272421, 109.256517457776)"
  }, "170"), /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 104,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-180, 450, 104)"
  }, "180"), /*#__PURE__*/React.createElement("text", {
    x: 510.0822694727579,
    y: 109.256517457776,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-170, 510.0822694727579, 109.256517457776)"
  }, "190"), /*#__PURE__*/React.createElement("text", {
    x: 568.3389695906815,
    y: 124.86635320807574,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-160, 568.3389695906815, 124.86635320807574)"
  }, "200"), /*#__PURE__*/React.createElement("text", {
    x: 623,
    y: 150.35521029058424,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-150, 623, 150.35521029058424)"
  }, "210"), /*#__PURE__*/React.createElement("text", {
    x: 672.4045129515426,
    y: 184.94862268083358,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-140, 672.4045129515426, 184.94862268083358)"
  }, "220"), /*#__PURE__*/React.createElement("text", {
    x: 715.0513773191665,
    y: 227.59548704845741,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-130, 715.0513773191665, 227.59548704845741)"
  }, "230"), /*#__PURE__*/React.createElement("text", {
    x: 749.6447897094158,
    y: 277,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-120, 749.6447897094158, 277)"
  }, "240"), /*#__PURE__*/React.createElement("text", {
    x: 775.1336467919243,
    y: 331.66103040931864,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-110, 775.1336467919243, 331.66103040931864)"
  }, "250"), /*#__PURE__*/React.createElement("text", {
    x: 790.743482542224,
    y: 389.9177305272421,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-100, 790.743482542224, 389.9177305272421)"
  }, "260"), /*#__PURE__*/React.createElement("text", {
    x: 796,
    y: 450,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-90, 796, 450)"
  }, "270"), /*#__PURE__*/React.createElement("text", {
    x: 790.743482542224,
    y: 510.0822694727579,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-80, 790.743482542224, 510.0822694727579)"
  }, "280"), /*#__PURE__*/React.createElement("text", {
    x: 775.1336467919243,
    y: 568.3389695906814,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-70, 775.1336467919243, 568.3389695906814)"
  }, "290"), /*#__PURE__*/React.createElement("text", {
    x: 749.6447897094158,
    y: 623,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-60, 749.6447897094158, 623)"
  }, "300"), /*#__PURE__*/React.createElement("text", {
    x: 715.0513773191665,
    y: 672.4045129515425,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-50, 715.0513773191665, 672.4045129515425)"
  }, "310"), /*#__PURE__*/React.createElement("text", {
    x: 672.4045129515426,
    y: 715.0513773191665,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-40, 672.4045129515426, 715.0513773191665)"
  }, "320"), /*#__PURE__*/React.createElement("text", {
    x: 623,
    y: 749.6447897094158,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-30, 623, 749.6447897094158)"
  }, "330"), /*#__PURE__*/React.createElement("text", {
    x: 568.3389695906815,
    y: 775.1336467919243,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-20, 568.3389695906815, 775.1336467919243)"
  }, "340"), /*#__PURE__*/React.createElement("text", {
    x: 510.0822694727579,
    y: 790.743482542224,
    fontSize: 20,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    alignmentBaseline: "middle",
    transform: "rotate(-10, 510.0822694727579, 790.743482542224)"
  }, "350"), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 372,
    fill: "none",
    stroke: "black",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "inner-ring-11"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 450,
    y1: 811,
    x2: 450,
    y2: 822,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.5775144310797,
    y1: 817.943951817552,
    x2: 443.50770480533055,
    y2: 821.9433425981775,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 437.1569852134794,
    y1: 817.7758243430271,
    x2: 437.01738722666937,
    y2: 821.7733876511036,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.7403681025965,
    y1: 817.4956687896831,
    x2: 430.53102427762474,
    y2: 821.4901869287014,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 424.3296176621618,
    y1: 817.1035704956153,
    x2: 424.05059176718527,
    y2: 821.0938266966546,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.1881538971047,
    y1: 813.6110648034871,
    x2: 417.57806369787113,
    y2: 820.5844276901294,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 411.53352551750356,
    y1: 815.9840574955247,
    x2: 411.11541166443294,
    y2: 819.9621450769978,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.15208162690584,
    y1: 815.2569838040065,
    x2: 404.66460425328523,
    y2: 819.2271684105718,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 398.7842988466961,
    y1: 814.4186492968979,
    x2: 398.22760644285586,
    y2: 818.3797215718641,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.432116865195,
    y1: 813.4693093390106,
    x2: 391.80637900503405,
    y2: 817.4200627013912,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 387.3130078622381,
    y1: 805.5155988374071,
    x2: 385.40287790790194,
    y2: 816.3484841205413,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 379.7822897014313,
    y1: 811.2388035087404,
    x2: 379.01905371992507,
    y2: 815.165312242531,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.4884977790644,
    y1: 809.9583170700405,
    x2: 372.65685101579334,
    y2: 813.8709074729757,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 367.21801200145757,
    y1: 808.5681838409665,
    x2: 366.3182077840821,
    y2: 812.4656641001075,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.97274241932223,
    y1: 807.0688272695668,
    x2: 360.0050548369236,
    y2: 810.9500101746708,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.53104853758,
    y1: 802.5629265955099,
    x2: 353.7193152218623,
    y2: 809.3244073795333,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.5654530593444,
    y1: 803.7443041053014,
    x2: 347.4629036360764,
    y2: 807.5893508890547,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 342.40721266203275,
    y1: 801.920150194397,
    x2: 341.2377258431418,
    y2: 805.7453692182492,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.28174607001927,
    y1: 799.9887979966165,
    x2: 335.0456780925195,
    y2: 803.793024061797,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.19091915976634,
    y1: 797.9508358205486,
    x2: 328.88864654193776,
    y2: 801.7329101229459,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 326.5307282594334,
    y1: 789.2290361037128,
    x2: 322.768506682851,
    y2: 799.5656549323578,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.12059456732936,
    y1: 793.5575969509703,
    x2: 316.6871227691481,
    y2: 797.2919186569591,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.1447736229443,
    y1: 791.2036584805778,
    x2: 310.64634724928067,
    y2: 794.9123938988448,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.2109447159472,
    y1: 788.7457860704981,
    x2: 304.6480202019901,
    y2: 792.4278054843078,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.3209153481056,
    y1: 786.1847284124772,
    x2: 298.6939687758024,
    y2: 789.8389102430476,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.7443344646445,
    y1: 780.8023422683772,
    x2: 292.7860066324596,
    y2: 787.1464967776337,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.6794179816194,
    y1: 780.7562090380934,
    x2: 286.9259333944631,
    y2: 784.35138522329,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.93149609584674,
    y1: 777.8904009013194,
    x2: 281.11553409688855,
    y2: 781.4544269980728,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 277.2344648947922,
    y1: 774.9247141720851,
    x2: 275.3565786436486,
    y2: 778.4565045435209,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.59005974934803,
    y1: 771.8600522272977,
    x2: 269.65082126836273,
    y2: 775.3585310558553,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.49999999999983,
    y1: 762.6351707661822,
    x2: 263.99999999999983,
    y2: 772.1614502078112,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.46598843309994,
    y1: 765.4375666583772,
    x2: 258.40583613345973,
    y2: 768.8662358611857,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.98971076218055,
    y1: 762.0816993855648,
    x2: 252.87003370524775,
    y2: 765.4738917701904,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.57283511447008,
    y1: 758.630769003916,
    x2: 247.39427897440996,
    y2: 761.9854512756978,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.217011522765,
    y1: 755.0858267002552,
    x2: 241.98023990888203,
    y2: 758.4019769904754,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.64460073186808,
    y1: 748.990496165482,
    x2: 236.62956567741074,
    y2: 754.7245604755049,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.69502715636983,
    y1: 747.7182539299806,
    x2: 231.34388614719995,
    y2: 750.9543219074803,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.53207148004623,
    y1: 743.8978676974037,
    x2: 226.12481138743806,
    y2: 747.092409737593,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.43657708015783,
    y1: 739.9879573272738,
    x2: 220.9739311788552,
    y2: 743.1400003417007,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.41009609365997,
    y1: 735.9897138161654,
    x2: 215.89281452946062,
    y2: 739.0982976619932,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.95367290315926,
    y1: 726.542043965951,
    x2: 210.8830091966073,
    y2: 734.9685328402597,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.57027733149317,
    y1: 727.7331255219799,
    x2: 205.94604121553112,
    y2: 730.7519638428711,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.7599368599401,
    y1: 723.477295775681,
    x2: 201.08341443450465,
    y2: 726.4498750775906,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.02460349700038,
    y1: 719.1381621958546,
    x2: 196.2966100567504,
    y2: 722.0635770023313,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.36571967108893,
    y1: 714.7170465246236,
    x2: 191.58708618925294,
    y2: 717.594405725978,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.90602486691012,
    y1: 708.0939751330898,
    x2: 186.95627739860424,
    y2: 713.0437226013956,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.28295347537642,
    y1: 705.634280328911,
    x2: 182.40559427402178,
    y2: 708.412913810747,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.86183780414524,
    y1: 700.9753965029994,
    x2: 177.93642299766856,
    y2: 703.7033899432494,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.52270422431894,
    y1: 696.2400631400599,
    x2: 173.55012492240934,
    y2: 698.9165855654953,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.26687447801993,
    y1: 691.4297226685067,
    x2: 169.24803615712887,
    y2: 694.0539587844687,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.4579560340489,
    y1: 682.0463270968406,
    x2: 165.03146715974015,
    y2: 689.1169908033926,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.01028618383475,
    y1: 681.5899039063403,
    x2: 160.90170233800688,
    y2: 684.1071854705397,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.01204267272624,
    y1: 676.5634229198421,
    x2: 156.85999965829933,
    y2: 679.0260688211447,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.10213230259615,
    y1: 671.4679285199537,
    x2: 152.90759026240698,
    y2: 673.8751886125619,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.28174607001932,
    y1: 666.3049728436301,
    x2: 149.04567809251955,
    y2: 668.6561138528,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.0095038345179,
    y1: 659.3553992681317,
    x2: 145.27543952449497,
    y2: 663.3704343225891,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.91417329974462,
    y1: 655.7829884772348,
    x2: 141.5980230095244,
    y2: 658.0197600911177,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.36923099608396,
    y1: 650.4271648855299,
    x2: 138.01454872430224,
    y2: 652.6057210255901,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.91830061443522,
    y1: 645.0102892378194,
    x2: 134.5261082298095,
    y2: 647.1299662947522,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.56243334162264,
    y1: 639.5340115669,
    x2: 131.13376413881423,
    y2: 641.5941638665402,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.36482923381766,
    y1: 630.5,
    x2: 127.83854979218881,
    y2: 636,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.13994777270233,
    y1: 628.409940250652,
    x2: 124.64146894414472,
    y2: 630.3491787316374,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.07528582791491,
    y1: 622.7655351052078,
    x2: 121.5434954564792,
    y2: 624.6434213563514,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.10959909868052,
    y1: 617.068503904153,
    x2: 118.54557300192704,
    y2: 618.8844659031112,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.24379096190648,
    y1: 611.3205820183804,
    x2: 115.64861477670985,
    y2: 613.0740666055367,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.19765773162271,
    y1: 604.2556655353552,
    x2: 112.85350322236616,
    y2: 607.2139933675401,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.81527158752277,
    y1: 599.6790846518943,
    x2: 110.16108975695238,
    y2: 601.3060312241976,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.25421392950193,
    y1: 593.7890552840527,
    x2: 107.57219451569216,
    y2: 595.3519797980098,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.79634151942224,
    y1: 587.8552263770556,
    x2: 105.08760610115507,
    y2: 589.3536527507192,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.44240304902974,
    y1: 581.8794054326705,
    x2: 102.70808134304093,
    y2: 583.3128772308518,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.77096389628707,
    y1: 573.4692717405663,
    x2: 100.43434506764208,
    y2: 577.2314933171488,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.04916417945145,
    y1: 569.8090808402337,
    x2: 98.26708987705416,
    y2: 571.1113534580624,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.01120200338352,
    y1: 563.7182539299807,
    x2: 96.2069759382029,
    y2: 564.9543219074806,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.07984980560292,
    y1: 557.592787337967,
    x2: 94.25463078175079,
    y2: 558.762274156858,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.25569589469865,
    y1: 551.4345469406557,
    x2: 92.41064911094537,
    y2: 552.5370963639236,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.43707340449004,
    y1: 544.4689514624199,
    x2: 90.67559262046655,
    y2: 546.2806847781376,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.93117273043327,
    y1: 539.0272575806777,
    x2: 89.04998982532925,
    y2: 539.9949451630763,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.43181615903342,
    y1: 532.7819879985423,
    x2: 87.53433589989248,
    y2: 533.6817922159178,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.0416829299595,
    y1: 526.5115022209353,
    x2: 86.12909252702428,
    y2: 527.3431489842063,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.76119649125968,
    y1: 520.2177102985685,
    x2: 84.834687757469,
    y2: 520.9809462800746,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.48440116259292,
    y1: 512.6869921377619,
    x2: 83.6515158794586,
    y2: 514.5971220920982,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.53069066098931,
    y1: 507.5678831348049,
    x2: 82.57993729860874,
    y2: 508.19362099496584,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.58135070310215,
    y1: 501.2157011533041,
    x2: 81.62027842813586,
    y2: 501.77239355714437,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.7430161959935,
    y1: 494.8479183730944,
    x2: 80.77283158942822,
    y2: 495.335395746715,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.01594250447539,
    y1: 488.4664744824963,
    x2: 80.03785492300227,
    y2: 488.88458833556695,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.38893519651288,
    y1: 481.8118461028952,
    x2: 79.41557230987064,
    y2: 482.42193630212876,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.89642950438463,
    y1: 475.67038233783796,
    x2: 78.90617330334538,
    y2: 475.94940823281445,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.50433121031682,
    y1: 469.2596318974032,
    x2: 78.50981307129854,
    y2: 469.46897572237503,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.22417565697276,
    y1: 462.8430147865203,
    x2: 78.22661234889637,
    y2: 462.98261277333035,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.05604818244802,
    y1: 456.4224855689202,
    x2: 78.05665740182246,
    y2: 456.49229519466934,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89,
    y1: 449.99999999999994,
    x2: 78,
    y2: 449.99999999999994,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.05604818244802,
    y1: 443.5775144310797,
    x2: 78.05665740182246,
    y2: 443.50770480533055,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.22417565697276,
    y1: 437.15698521347974,
    x2: 78.22661234889637,
    y2: 437.0173872266697,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.50433121031682,
    y1: 430.7403681025967,
    x2: 78.50981307129854,
    y2: 430.5310242776249,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.89642950438468,
    y1: 424.3296176621618,
    x2: 78.90617330334538,
    y2: 424.0505917671853,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.38893519651288,
    y1: 418.1881538971046,
    x2: 79.41557230987064,
    y2: 417.578063697871,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.01594250447545,
    y1: 411.53352551750345,
    x2: 80.03785492300233,
    y2: 411.1154116644328,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.7430161959935,
    y1: 405.1520816269057,
    x2: 80.77283158942822,
    y2: 404.6646042532851,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.58135070310215,
    y1: 398.78429884669583,
    x2: 81.62027842813586,
    y2: 398.2276064428555,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.53069066098936,
    y1: 392.432116865195,
    x2: 82.5799372986088,
    y2: 391.80637900503405,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.48440116259292,
    y1: 387.3130078622382,
    x2: 83.6515158794586,
    y2: 385.40287790790194,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.76119649125968,
    y1: 379.78228970143147,
    x2: 84.834687757469,
    y2: 379.0190537199253,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.0416829299595,
    y1: 373.4884977790646,
    x2: 86.12909252702428,
    y2: 372.65685101579356,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.43181615903342,
    y1: 367.21801200145774,
    x2: 87.53433589989248,
    y2: 366.3182077840823,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.93117273043327,
    y1: 360.9727424193223,
    x2: 89.0499898253293,
    y2: 360.0050548369236,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.43707340449009,
    y1: 355.53104853757986,
    x2: 90.6755926204666,
    y2: 353.7193152218622,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.2556958946987,
    y1: 348.5654530593441,
    x2: 92.41064911094543,
    y2: 347.46290363607613,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.07984980560298,
    y1: 342.40721266203275,
    x2: 94.25463078175079,
    y2: 341.2377258431418,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.01120200338352,
    y1: 336.2817460700193,
    x2: 96.2069759382029,
    y2: 335.04567809251955,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.04916417945145,
    y1: 330.1909191597662,
    x2: 98.26708987705416,
    y2: 328.8886465419376,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.77096389628707,
    y1: 326.53072825943354,
    x2: 100.43434506764208,
    y2: 322.7685066828512,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.44240304902974,
    y1: 318.12059456732953,
    x2: 102.70808134304093,
    y2: 316.68712276914835,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.79634151942224,
    y1: 312.1447736229443,
    x2: 105.08760610115513,
    y2: 310.64634724928067,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.25421392950204,
    y1: 306.2109447159471,
    x2: 107.57219451569227,
    y2: 304.64802020199,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.81527158752294,
    y1: 300.3209153481055,
    x2: 110.16108975695249,
    y2: 298.6939687758022,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.19765773162277,
    y1: 295.7443344646447,
    x2: 112.85350322236621,
    y2: 292.7860066324598,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.24379096190654,
    y1: 288.67941798161957,
    x2: 115.64861477670985,
    y2: 286.92593339446324,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.10959909868063,
    y1: 282.9314960958468,
    x2: 118.54557300192721,
    y2: 281.1155340968886,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.07528582791497,
    y1: 277.23446489479204,
    x2: 121.54349545647926,
    y2: 275.3565786436485,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.13994777270239,
    y1: 271.5900597493479,
    x2: 124.64146894414478,
    y2: 269.65082126836256,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.3648292338176,
    y1: 269.5,
    x2: 127.83854979218881,
    y2: 264,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.5624333416227,
    y1: 260.4659884331,
    x2: 131.13376413881423,
    y2: 258.40583613345973,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.91830061443522,
    y1: 254.9897107621806,
    x2: 134.52610822980955,
    y2: 252.87003370524778,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.3692309960839,
    y1: 249.5728351144701,
    x2: 138.0145487243022,
    y2: 247.39427897441,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.91417329974468,
    y1: 244.21701152276515,
    x2: 141.59802300952452,
    y2: 241.98023990888214,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.00950383451806,
    y1: 240.64460073186808,
    x2: 145.27543952449514,
    y2: 236.62956567741074,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.28174607001938,
    y1: 233.69502715636983,
    x2: 149.0456780925196,
    y2: 231.34388614719995,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.1021323025962,
    y1: 228.53207148004628,
    x2: 152.90759026240704,
    y2: 226.1248113874381,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.01204267272635,
    y1: 223.43657708015772,
    x2: 156.85999965829944,
    y2: 220.97393117885508,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.0102861838348,
    y1: 218.41009609365972,
    x2: 160.90170233800688,
    y2: 215.89281452946037,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.457956034049,
    y1: 217.95367290315926,
    x2: 165.0314671597402,
    y2: 210.8830091966073,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.26687447801987,
    y1: 208.57027733149332,
    x2: 169.2480361571288,
    y2: 205.9460412155313,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.52270422431894,
    y1: 203.7599368599401,
    x2: 173.5501249224094,
    y2: 201.08341443450465,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.8618378041453,
    y1: 199.02460349700056,
    x2: 177.93642299766861,
    y2: 196.29661005675058,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.2829534753763,
    y1: 194.36571967108904,
    x2: 182.40559427402172,
    y2: 191.58708618925306,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.90602486691017,
    y1: 191.90602486691012,
    x2: 186.95627739860436,
    y2: 186.9562773986043,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.3657196710891,
    y1: 185.2829534753763,
    x2: 191.5870861892531,
    y2: 182.40559427402167,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.0246034970006,
    y1: 180.86183780414524,
    x2: 196.2966100567506,
    y2: 177.93642299766856,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.75993685994018,
    y1: 176.52270422431894,
    x2: 201.08341443450473,
    y2: 173.55012492240934,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.57027733149323,
    y1: 172.26687447802,
    x2: 205.9460412155312,
    y2: 169.24803615712887,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.9536729031593,
    y1: 173.45795603404895,
    x2: 210.88300919660736,
    y2: 165.0314671597402,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.4100960936599,
    y1: 164.0102861838347,
    x2: 215.89281452946054,
    y2: 160.90170233800677,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.43657708015775,
    y1: 160.0120426727263,
    x2: 220.9739311788551,
    y2: 156.8599996582994,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.5320714800462,
    y1: 156.10213230259626,
    x2: 226.124811387438,
    y2: 152.9075902624071,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.69502715636992,
    y1: 152.28174607001932,
    x2: 231.34388614720004,
    y2: 149.04567809251955,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.64460073186828,
    y1: 151.0095038345179,
    x2: 236.62956567741097,
    y2: 145.27543952449497,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.21701152276523,
    y1: 144.91417329974462,
    x2: 241.98023990888223,
    y2: 141.59802300952447,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.57283511447002,
    y1: 141.36923099608396,
    x2: 247.39427897440993,
    y2: 138.01454872430224,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.98971076218064,
    y1: 137.91830061443522,
    x2: 252.8700337052478,
    y2: 134.5261082298095,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.46598843310005,
    y1: 134.56243334162264,
    x2: 258.40583613345984,
    y2: 131.13376413881423,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.5000000000001,
    y1: 137.3648292338176,
    x2: 264.0000000000001,
    y2: 127.83854979218881,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.590059749348,
    y1: 128.13994777270233,
    x2: 269.6508212683626,
    y2: 124.64146894414472,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 277.23446489479227,
    y1: 125.07528582791485,
    x2: 275.35657864364873,
    y2: 121.54349545647909,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.9314960958468,
    y1: 122.10959909868063,
    x2: 281.1155340968886,
    y2: 118.54557300192715,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.6794179816195,
    y1: 119.2437909619066,
    x2: 286.9259333944632,
    y2: 115.6486147767099,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.74433446464474,
    y1: 119.19765773162271,
    x2: 292.7860066324598,
    y2: 112.85350322236616,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.3209153481056,
    y1: 113.81527158752283,
    x2: 298.6939687758024,
    y2: 110.16108975695244,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.21094471594733,
    y1: 111.25421392950193,
    x2: 304.6480202019902,
    y2: 107.57219451569216,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.1447736229444,
    y1: 108.79634151942224,
    x2: 310.6463472492807,
    y2: 105.08760610115507,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.1205945673295,
    y1: 106.44240304902974,
    x2: 316.6871227691483,
    y2: 102.70808134304093,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 326.5307282594336,
    y1: 110.77096389628707,
    x2: 322.76850668285124,
    y2: 100.43434506764208,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.19091915976645,
    y1: 102.0491641794514,
    x2: 328.8886465419378,
    y2: 98.26708987705416,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.2817460700194,
    y1: 100.01120200338346,
    x2: 335.0456780925196,
    y2: 96.20697593820285,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 342.4072126620329,
    y1: 98.07984980560292,
    x2: 341.23772584314196,
    y2: 94.25463078175079,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.56545305934435,
    y1: 96.25569589469865,
    x2: 347.46290363607636,
    y2: 92.41064911094537,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.53104853757986,
    y1: 97.43707340449009,
    x2: 353.71931522186225,
    y2: 90.6755926204666,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.97274241932223,
    y1: 92.93117273043327,
    x2: 360.0050548369236,
    y2: 89.0499898253293,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 367.21801200145774,
    y1: 91.43181615903342,
    x2: 366.3182077840823,
    y2: 87.53433589989248,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.48849777906463,
    y1: 90.0416829299595,
    x2: 372.6568510157936,
    y2: 86.12909252702428,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 379.7822897014315,
    y1: 88.76119649125968,
    x2: 379.01905371992535,
    y2: 84.834687757469,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 387.3130078622382,
    y1: 94.48440116259292,
    x2: 385.40287790790194,
    y2: 83.6515158794586,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.432116865195,
    y1: 86.53069066098936,
    x2: 391.80637900503405,
    y2: 82.5799372986088,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 398.78429884669595,
    y1: 85.58135070310209,
    x2: 398.2276064428557,
    y2: 81.6202784281358,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.1520816269058,
    y1: 84.74301619599345,
    x2: 404.6646042532852,
    y2: 80.77283158942816,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 411.53352551750356,
    y1: 84.01594250447539,
    x2: 411.11541166443294,
    y2: 80.03785492300227,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.18815389710477,
    y1: 86.38893519651288,
    x2: 417.57806369787113,
    y2: 79.41557230987064,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 424.32961766216187,
    y1: 82.89642950438468,
    x2: 424.0505917671854,
    y2: 78.90617330334538,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.74036810259673,
    y1: 82.50433121031682,
    x2: 430.53102427762497,
    y2: 78.50981307129854,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 437.15698521347974,
    y1: 82.22417565697276,
    x2: 437.0173872266697,
    y2: 78.22661234889637,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.5775144310797,
    y1: 82.05604818244802,
    x2: 443.50770480533055,
    y2: 78.05665740182246,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450,
    y1: 89,
    x2: 450,
    y2: 78,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.4224855689203,
    y1: 82.05604818244802,
    x2: 456.4922951946694,
    y2: 78.05665740182246,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.84301478652037,
    y1: 82.22417565697276,
    x2: 462.9826127733304,
    y2: 78.22661234889637,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 469.2596318974034,
    y1: 82.50433121031682,
    x2: 469.46897572237515,
    y2: 78.50981307129854,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.6703823378382,
    y1: 82.89642950438468,
    x2: 475.9494082328147,
    y2: 78.90617330334538,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 481.81184610289523,
    y1: 86.38893519651288,
    x2: 482.4219363021288,
    y2: 79.41557230987064,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 488.4664744824965,
    y1: 84.01594250447545,
    x2: 488.88458833556706,
    y2: 80.03785492300233,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 494.8479183730943,
    y1: 84.7430161959935,
    x2: 495.3353957467149,
    y2: 80.77283158942822,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 501.21570115330417,
    y1: 85.58135070310215,
    x2: 501.7723935571444,
    y2: 81.62027842813586,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 507.56788313480496,
    y1: 86.53069066098931,
    x2: 508.1936209949659,
    y2: 82.57993729860874,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 512.6869921377619,
    y1: 94.48440116259292,
    x2: 514.5971220920981,
    y2: 83.6515158794586,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.2177102985686,
    y1: 88.76119649125968,
    x2: 520.9809462800747,
    y2: 84.834687757469,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 526.5115022209354,
    y1: 90.04168292995956,
    x2: 527.3431489842066,
    y2: 86.12909252702434,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 532.7819879985423,
    y1: 91.43181615903342,
    x2: 533.6817922159178,
    y2: 87.53433589989248,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 539.0272575806778,
    y1: 92.93117273043327,
    x2: 539.9949451630764,
    y2: 89.0499898253293,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 544.46895146242,
    y1: 97.43707340449009,
    x2: 546.2806847781377,
    y2: 90.6755926204666,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 551.4345469406557,
    y1: 96.25569589469865,
    x2: 552.5370963639236,
    y2: 92.41064911094537,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.5927873379671,
    y1: 98.07984980560298,
    x2: 558.7622741568581,
    y2: 94.25463078175079,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.7182539299806,
    y1: 100.01120200338352,
    x2: 564.9543219074804,
    y2: 96.2069759382029,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.8090808402337,
    y1: 102.04916417945145,
    x2: 571.1113534580624,
    y2: 98.26708987705416,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.4692717405665,
    y1: 110.77096389628707,
    x2: 577.2314933171488,
    y2: 100.43434506764208,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 581.8794054326705,
    y1: 106.44240304902974,
    x2: 583.3128772308518,
    y2: 102.70808134304093,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 587.8552263770556,
    y1: 108.79634151942224,
    x2: 589.3536527507192,
    y2: 105.08760610115507,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 593.7890552840528,
    y1: 111.25421392950199,
    x2: 595.3519797980099,
    y2: 107.57219451569222,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 599.6790846518945,
    y1: 113.81527158752289,
    x2: 601.3060312241977,
    y2: 110.16108975695249,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 604.2556655353553,
    y1: 119.19765773162277,
    x2: 607.2139933675402,
    y2: 112.85350322236621,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 611.3205820183805,
    y1: 119.24379096190654,
    x2: 613.0740666055368,
    y2: 115.64861477670985,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 617.0685039041532,
    y1: 122.10959909868063,
    x2: 618.8844659031114,
    y2: 118.54557300192721,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 622.7655351052078,
    y1: 125.07528582791491,
    x2: 624.6434213563514,
    y2: 121.5434954564792,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 628.4099402506521,
    y1: 128.13994777270239,
    x2: 630.3491787316374,
    y2: 124.64146894414478,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 630.5,
    y1: 137.36482923381766,
    x2: 636,
    y2: 127.83854979218881,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 639.5340115669001,
    y1: 134.5624333416227,
    x2: 641.5941638665403,
    y2: 131.13376413881423,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 645.0102892378194,
    y1: 137.91830061443522,
    x2: 647.1299662947522,
    y2: 134.5261082298095,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 650.42716488553,
    y1: 141.369230996084,
    x2: 652.6057210255901,
    y2: 138.0145487243023,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 655.7829884772348,
    y1: 144.91417329974462,
    x2: 658.0197600911179,
    y2: 141.59802300952447,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 659.3553992681318,
    y1: 151.009503834518,
    x2: 663.3704343225891,
    y2: 145.27543952449503,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 666.3049728436301,
    y1: 152.28174607001932,
    x2: 668.6561138528,
    y2: 149.04567809251955,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 671.4679285199538,
    y1: 156.10213230259626,
    x2: 673.8751886125619,
    y2: 152.90759026240704,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 676.5634229198422,
    y1: 160.0120426727263,
    x2: 679.0260688211449,
    y2: 156.8599996582994,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 681.5899039063402,
    y1: 164.01028618383475,
    x2: 684.1071854705395,
    y2: 160.90170233800688,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 682.0463270968407,
    y1: 173.45795603404895,
    x2: 689.1169908033926,
    y2: 165.0314671597402,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 691.4297226685067,
    y1: 172.26687447801987,
    x2: 694.0539587844687,
    y2: 169.2480361571288,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 696.2400631400599,
    y1: 176.52270422431894,
    x2: 698.9165855654953,
    y2: 173.55012492240934,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700.9753965029995,
    y1: 180.8618378041453,
    x2: 703.7033899432495,
    y2: 177.93642299766861,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 705.634280328911,
    y1: 185.28295347537642,
    x2: 708.412913810747,
    y2: 182.40559427402178,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 708.0939751330899,
    y1: 191.90602486691017,
    x2: 713.0437226013958,
    y2: 186.95627739860436,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 714.7170465246236,
    y1: 194.365719671089,
    x2: 717.5944057259783,
    y2: 191.587086189253,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 719.1381621958548,
    y1: 199.02460349700056,
    x2: 722.0635770023314,
    y2: 196.29661005675058,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 723.4772957756811,
    y1: 203.75993685994018,
    x2: 726.4498750775906,
    y2: 201.08341443450473,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 727.7331255219801,
    y1: 208.57027733149337,
    x2: 730.7519638428712,
    y2: 205.94604121553132,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 726.542043965951,
    y1: 217.95367290315934,
    x2: 734.9685328402597,
    y2: 210.8830091966074,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 735.9897138161652,
    y1: 218.41009609365983,
    x2: 739.0982976619932,
    y2: 215.89281452946048,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 739.9879573272738,
    y1: 223.4365770801578,
    x2: 743.1400003417007,
    y2: 220.97393117885517,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 743.8978676974037,
    y1: 228.53207148004623,
    x2: 747.092409737593,
    y2: 226.12481138743806,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 747.7182539299806,
    y1: 233.6950271563699,
    x2: 750.9543219074804,
    y2: 231.34388614719998,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 748.990496165482,
    y1: 240.6446007318682,
    x2: 754.724560475505,
    y2: 236.62956567741088,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 755.0858267002553,
    y1: 244.21701152276515,
    x2: 758.4019769904755,
    y2: 241.98023990888214,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 758.630769003916,
    y1: 249.57283511447002,
    x2: 761.9854512756978,
    y2: 247.39427897440993,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 762.0816993855648,
    y1: 254.9897107621806,
    x2: 765.4738917701904,
    y2: 252.87003370524778,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 765.4375666583774,
    y1: 260.46598843310005,
    x2: 768.8662358611857,
    y2: 258.40583613345984,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 762.6351707661825,
    y1: 269.5,
    x2: 772.1614502078112,
    y2: 264,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 771.8600522272976,
    y1: 271.590059749348,
    x2: 775.3585310558552,
    y2: 269.6508212683626,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 774.9247141720851,
    y1: 277.23446489479215,
    x2: 778.4565045435209,
    y2: 275.3565786436486,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 777.8904009013194,
    y1: 282.9314960958468,
    x2: 781.4544269980729,
    y2: 281.1155340968886,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780.7562090380934,
    y1: 288.6794179816195,
    x2: 784.3513852232902,
    y2: 286.9259333944632,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780.8023422683773,
    y1: 295.7443344646447,
    x2: 787.1464967776337,
    y2: 292.7860066324598,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 786.1847284124772,
    y1: 300.32091534810553,
    x2: 789.8389102430475,
    y2: 298.6939687758023,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 788.7457860704981,
    y1: 306.2109447159473,
    x2: 792.4278054843078,
    y2: 304.64802020199016,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 791.2036584805778,
    y1: 312.1447736229444,
    x2: 794.9123938988449,
    y2: 310.6463472492807,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 793.5575969509703,
    y1: 318.1205945673295,
    x2: 797.2919186569591,
    y2: 316.6871227691483,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 789.2290361037129,
    y1: 326.5307282594336,
    x2: 799.5656549323579,
    y2: 322.76850668285124,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 797.9508358205486,
    y1: 330.19091915976634,
    x2: 801.7329101229459,
    y2: 328.88864654193776,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 799.9887979966165,
    y1: 336.2817460700194,
    x2: 803.793024061797,
    y2: 335.04567809251955,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 801.920150194397,
    y1: 342.40721266203286,
    x2: 805.7453692182492,
    y2: 341.2377258431419,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 803.7443041053014,
    y1: 348.5654530593443,
    x2: 807.5893508890547,
    y2: 347.4629036360763,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 802.5629265955099,
    y1: 355.5310485375799,
    x2: 809.3244073795333,
    y2: 353.7193152218623,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 807.0688272695668,
    y1: 360.9727424193223,
    x2: 810.9500101746708,
    y2: 360.0050548369236,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 808.5681838409666,
    y1: 367.2180120014577,
    x2: 812.4656641001075,
    y2: 366.31820778408223,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 809.9583170700405,
    y1: 373.4884977790646,
    x2: 813.8709074729757,
    y2: 372.65685101579356,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 811.2388035087404,
    y1: 379.7822897014315,
    x2: 815.165312242531,
    y2: 379.01905371992535,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 805.5155988374071,
    y1: 387.3130078622381,
    x2: 816.3484841205413,
    y2: 385.40287790790194,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 813.4693093390107,
    y1: 392.43211686519504,
    x2: 817.4200627013913,
    y2: 391.8063790050341,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 814.4186492968979,
    y1: 398.78429884669595,
    x2: 818.3797215718641,
    y2: 398.22760644285563,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 815.2569838040065,
    y1: 405.1520816269057,
    x2: 819.2271684105717,
    y2: 404.6646042532851,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 815.9840574955246,
    y1: 411.5335255175035,
    x2: 819.9621450769977,
    y2: 411.11541166443294,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 813.6110648034871,
    y1: 418.18815389710477,
    x2: 820.5844276901294,
    y2: 417.5780636978712,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 817.1035704956153,
    y1: 424.32961766216187,
    x2: 821.0938266966546,
    y2: 424.0505917671854,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 817.4956687896831,
    y1: 430.7403681025967,
    x2: 821.4901869287014,
    y2: 430.5310242776249,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 817.7758243430272,
    y1: 437.15698521347963,
    x2: 821.7733876511036,
    y2: 437.01738722666965,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 817.943951817552,
    y1: 443.5775144310797,
    x2: 821.9433425981775,
    y2: 443.50770480533055,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 811,
    y1: 450,
    x2: 822,
    y2: 450,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 817.943951817552,
    y1: 456.4224855689203,
    x2: 821.9433425981775,
    y2: 456.49229519466945,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 817.7758243430272,
    y1: 462.84301478652037,
    x2: 821.7733876511036,
    y2: 462.98261277333035,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 817.4956687896831,
    y1: 469.2596318974033,
    x2: 821.4901869287014,
    y2: 469.4689757223751,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 817.1035704956153,
    y1: 475.67038233783813,
    x2: 821.0938266966546,
    y2: 475.9494082328146,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 813.6110648034871,
    y1: 481.81184610289523,
    x2: 820.5844276901294,
    y2: 482.4219363021288,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 815.9840574955246,
    y1: 488.4664744824965,
    x2: 819.9621450769977,
    y2: 488.88458833556706,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 815.2569838040065,
    y1: 494.8479183730943,
    x2: 819.2271684105717,
    y2: 495.3353957467149,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 814.4186492968979,
    y1: 501.21570115330405,
    x2: 818.3797215718641,
    y2: 501.77239355714437,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 813.4693093390107,
    y1: 507.56788313480496,
    x2: 817.4200627013913,
    y2: 508.1936209949659,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 805.5155988374071,
    y1: 512.6869921377619,
    x2: 816.3484841205413,
    y2: 514.5971220920981,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 811.2388035087404,
    y1: 520.2177102985685,
    x2: 815.165312242531,
    y2: 520.9809462800747,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 809.9583170700405,
    y1: 526.5115022209354,
    x2: 813.8709074729757,
    y2: 527.3431489842064,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 808.5681838409666,
    y1: 532.7819879985423,
    x2: 812.4656641001075,
    y2: 533.6817922159178,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 807.0688272695668,
    y1: 539.0272575806778,
    x2: 810.9500101746708,
    y2: 539.9949451630764,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 802.5629265955099,
    y1: 544.46895146242,
    x2: 809.3244073795333,
    y2: 546.2806847781377,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 803.7443041053014,
    y1: 551.4345469406557,
    x2: 807.5893508890547,
    y2: 552.5370963639236,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 801.920150194397,
    y1: 557.5927873379671,
    x2: 805.7453692182492,
    y2: 558.7622741568581,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 799.9887979966165,
    y1: 563.7182539299806,
    x2: 803.793024061797,
    y2: 564.9543219074804,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 797.9508358205486,
    y1: 569.8090808402336,
    x2: 801.7329101229459,
    y2: 571.1113534580622,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 789.2290361037129,
    y1: 573.4692717405665,
    x2: 799.5656549323579,
    y2: 577.2314933171488,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 793.5575969509703,
    y1: 581.8794054326705,
    x2: 797.2919186569591,
    y2: 583.3128772308517,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 791.2036584805778,
    y1: 587.8552263770556,
    x2: 794.9123938988449,
    y2: 589.3536527507192,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 788.7457860704981,
    y1: 593.7890552840527,
    x2: 792.4278054843078,
    y2: 595.3519797980098,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 786.1847284124772,
    y1: 599.6790846518945,
    x2: 789.8389102430475,
    y2: 601.3060312241977,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780.8023422683773,
    y1: 604.2556655353553,
    x2: 787.1464967776337,
    y2: 607.2139933675402,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780.7562090380934,
    y1: 611.3205820183805,
    x2: 784.3513852232902,
    y2: 613.0740666055368,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 777.8904009013194,
    y1: 617.0685039041532,
    x2: 781.4544269980729,
    y2: 618.8844659031114,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 774.9247141720851,
    y1: 622.7655351052078,
    x2: 778.4565045435209,
    y2: 624.6434213563514,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 771.8600522272976,
    y1: 628.409940250652,
    x2: 775.3585310558552,
    y2: 630.3491787316374,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 762.6351707661825,
    y1: 630.5,
    x2: 772.1614502078112,
    y2: 636,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 765.4375666583774,
    y1: 639.5340115669,
    x2: 768.8662358611857,
    y2: 641.5941638665402,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 762.0816993855648,
    y1: 645.0102892378194,
    x2: 765.4738917701904,
    y2: 647.1299662947522,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 758.630769003916,
    y1: 650.4271648855299,
    x2: 761.9854512756978,
    y2: 652.6057210255901,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 755.0858267002553,
    y1: 655.7829884772349,
    x2: 758.4019769904755,
    y2: 658.0197600911179,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 748.990496165482,
    y1: 659.3553992681318,
    x2: 754.724560475505,
    y2: 663.3704343225891,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 747.7182539299806,
    y1: 666.3049728436301,
    x2: 750.9543219074804,
    y2: 668.6561138528,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 743.8978676974037,
    y1: 671.4679285199538,
    x2: 747.092409737593,
    y2: 673.8751886125619,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 739.9879573272738,
    y1: 676.5634229198422,
    x2: 743.1400003417007,
    y2: 679.0260688211448,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 735.9897138161652,
    y1: 681.5899039063402,
    x2: 739.0982976619932,
    y2: 684.1071854705395,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 726.542043965951,
    y1: 682.0463270968406,
    x2: 734.9685328402597,
    y2: 689.1169908033926,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 727.7331255219801,
    y1: 691.4297226685067,
    x2: 730.7519638428712,
    y2: 694.0539587844687,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 723.4772957756811,
    y1: 696.2400631400599,
    x2: 726.4498750775906,
    y2: 698.9165855654953,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 719.1381621958548,
    y1: 700.9753965029995,
    x2: 722.0635770023314,
    y2: 703.7033899432495,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 714.7170465246236,
    y1: 705.634280328911,
    x2: 717.5944057259783,
    y2: 708.412913810747,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 708.0939751330899,
    y1: 708.0939751330898,
    x2: 713.0437226013958,
    y2: 713.0437226013956,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 705.634280328911,
    y1: 714.7170465246236,
    x2: 708.412913810747,
    y2: 717.5944057259783,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700.9753965029995,
    y1: 719.1381621958546,
    x2: 703.7033899432495,
    y2: 722.0635770023314,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 696.2400631400599,
    y1: 723.4772957756811,
    x2: 698.9165855654953,
    y2: 726.4498750775906,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 691.4297226685067,
    y1: 727.7331255219801,
    x2: 694.0539587844687,
    y2: 730.7519638428712,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 682.0463270968407,
    y1: 726.542043965951,
    x2: 689.1169908033926,
    y2: 734.9685328402597,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 681.5899039063402,
    y1: 735.9897138161652,
    x2: 684.1071854705395,
    y2: 739.0982976619931,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 676.5634229198422,
    y1: 739.9879573272738,
    x2: 679.0260688211449,
    y2: 743.1400003417007,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 671.4679285199538,
    y1: 743.8978676974037,
    x2: 673.8751886125619,
    y2: 747.092409737593,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 666.3049728436301,
    y1: 747.7182539299806,
    x2: 668.6561138528,
    y2: 750.9543219074804,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 659.3553992681318,
    y1: 748.990496165482,
    x2: 663.3704343225891,
    y2: 754.724560475505,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 655.7829884772348,
    y1: 755.0858267002554,
    x2: 658.0197600911179,
    y2: 758.4019769904755,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 650.42716488553,
    y1: 758.6307690039159,
    x2: 652.6057210255901,
    y2: 761.9854512756976,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 645.0102892378194,
    y1: 762.0816993855648,
    x2: 647.1299662947522,
    y2: 765.4738917701904,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 639.5340115669001,
    y1: 765.4375666583774,
    x2: 641.5941638665403,
    y2: 768.8662358611857,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 630.5,
    y1: 762.6351707661823,
    x2: 636,
    y2: 772.1614502078112,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 628.4099402506521,
    y1: 771.8600522272976,
    x2: 630.3491787316374,
    y2: 775.3585310558552,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 622.7655351052078,
    y1: 774.924714172085,
    x2: 624.6434213563514,
    y2: 778.4565045435209,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 617.0685039041532,
    y1: 777.8904009013194,
    x2: 618.8844659031114,
    y2: 781.4544269980728,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 611.3205820183805,
    y1: 780.7562090380934,
    x2: 613.0740666055368,
    y2: 784.3513852232902,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 604.2556655353553,
    y1: 780.8023422683773,
    x2: 607.2139933675402,
    y2: 787.1464967776337,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 599.6790846518945,
    y1: 786.1847284124772,
    x2: 601.3060312241977,
    y2: 789.8389102430475,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 593.7890552840528,
    y1: 788.7457860704981,
    x2: 595.3519797980099,
    y2: 792.4278054843078,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 587.8552263770556,
    y1: 791.2036584805778,
    x2: 589.3536527507192,
    y2: 794.9123938988449,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 581.8794054326705,
    y1: 793.5575969509703,
    x2: 583.3128772308518,
    y2: 797.2919186569591,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.4692717405665,
    y1: 789.2290361037129,
    x2: 577.2314933171488,
    y2: 799.5656549323579,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.8090808402337,
    y1: 797.9508358205485,
    x2: 571.1113534580624,
    y2: 801.7329101229459,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.7182539299806,
    y1: 799.9887979966165,
    x2: 564.9543219074804,
    y2: 803.793024061797,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.5927873379671,
    y1: 801.920150194397,
    x2: 558.7622741568581,
    y2: 805.7453692182492,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 551.4345469406557,
    y1: 803.7443041053014,
    x2: 552.5370963639236,
    y2: 807.5893508890547,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 544.46895146242,
    y1: 802.5629265955099,
    x2: 546.2806847781377,
    y2: 809.3244073795333,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 539.0272575806778,
    y1: 807.0688272695668,
    x2: 539.9949451630764,
    y2: 810.9500101746708,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 532.7819879985423,
    y1: 808.5681838409666,
    x2: 533.6817922159178,
    y2: 812.4656641001075,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 526.5115022209354,
    y1: 809.9583170700405,
    x2: 527.3431489842066,
    y2: 813.8709074729757,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.2177102985686,
    y1: 811.2388035087404,
    x2: 520.9809462800747,
    y2: 815.165312242531,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 512.6869921377619,
    y1: 805.5155988374071,
    x2: 514.5971220920981,
    y2: 816.3484841205413,
    stroke: "black",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 507.56788313480496,
    y1: 813.4693093390107,
    x2: 508.1936209949659,
    y2: 817.4200627013913,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 501.21570115330417,
    y1: 814.4186492968979,
    x2: 501.7723935571444,
    y2: 818.3797215718641,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 494.8479183730943,
    y1: 815.2569838040065,
    x2: 495.3353957467149,
    y2: 819.2271684105717,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 488.4664744824965,
    y1: 815.9840574955246,
    x2: 488.88458833556706,
    y2: 819.9621450769977,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 481.81184610289523,
    y1: 813.6110648034871,
    x2: 482.4219363021288,
    y2: 820.5844276901294,
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.6703823378382,
    y1: 817.1035704956153,
    x2: 475.9494082328147,
    y2: 821.0938266966546,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 469.2596318974034,
    y1: 817.4956687896831,
    x2: 469.46897572237515,
    y2: 821.4901869287014,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.84301478652037,
    y1: 817.7758243430272,
    x2: 462.9826127733304,
    y2: 821.7733876511036,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.4224855689203,
    y1: 817.943951817552,
    x2: 456.4922951946694,
    y2: 821.9433425981775,
    stroke: "black",
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 372,
    fill: "none",
    stroke: "black",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "inner-three-rings"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "inner-ring-4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 280,
    fill: "none",
    stroke: "black",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 258,
    fill: "none",
    stroke: "black",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 548.7323255501932,
    y1: 688.360919387912,
    x2: 557.1513610622252,
    y2: 708.6862691031603,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.1311422146388,
    y1: 678.8487949599812,
    x2: 579.2896117058095,
    y2: 698.363033289902,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 588.6232989534806,
    y1: 667.5949930197245,
    x2: 600.4438903371107,
    y2: 686.149604827608,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 607.0604486842499,
    y1: 654.6851617951387,
    x2: 620.4532001224418,
    y2: 672.1389352815459,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 624.3022735648403,
    y1: 640.217552897012,
    x2: 639.1652581323849,
    y2: 656.4376543068347,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.217552897012,
    y1: 624.3022735648403,
    x2: 656.4376543068347,
    y2: 639.1652581323849,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 654.6851617951387,
    y1: 607.0604486842499,
    x2: 672.1389352815459,
    y2: 620.4532001224418,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 667.5949930197245,
    y1: 588.6232989534806,
    x2: 686.1496048276081,
    y2: 600.4438903371107,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 678.8487949599812,
    y1: 569.1311422146388,
    x2: 698.3630332899021,
    y2: 579.2896117058095,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 688.360919387912,
    y1: 548.7323255501932,
    x2: 708.6862691031603,
    y2: 557.1513610622251,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 696.0589732930425,
    y1: 527.5820962721025,
    x2: 717.0407462095036,
    y2: 534.1976238611965,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 701.8843698369428,
    y1: 505.84142039603057,
    x2: 723.3628819935814,
    y2: 510.6030919026688,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 705.7927742344431,
    y1: 483.6757575927733,
    x2: 727.6045611846669,
    y2: 486.5473338216144,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 707.7544411681192,
    y1: 461.25380194025666,
    x2: 729.7335020429202,
    y2: 462.2134284622941,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 707.7544411681192,
    y1: 438.74619805974334,
    x2: 729.7335020429202,
    y2: 437.7865715377059,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 705.7927742344431,
    y1: 416.3242424072267,
    x2: 727.6045611846669,
    y2: 413.4526661783856,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 701.8843698369428,
    y1: 394.15857960396943,
    x2: 723.3628819935814,
    y2: 389.3969080973312,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 696.0589732930425,
    y1: 372.4179037278975,
    x2: 717.0407462095036,
    y2: 365.80237613880354,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 688.360919387912,
    y1: 351.2676744498068,
    x2: 708.6862691031603,
    y2: 342.84863893777487,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 678.8487949599812,
    y1: 330.86885778536123,
    x2: 698.3630332899021,
    y2: 320.71038829419047,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 667.5949930197245,
    y1: 311.37670104651943,
    x2: 686.1496048276081,
    y2: 299.5561096628893,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 654.6851617951387,
    y1: 292.93955131575007,
    x2: 672.1389352815459,
    y2: 279.5467998775582,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.217552897012,
    y1: 275.69772643515967,
    x2: 656.4376543068347,
    y2: 260.8347418676151,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 624.3022735648403,
    y1: 259.782447102988,
    x2: 639.1652581323849,
    y2: 243.56234569316527,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 607.0604486842499,
    y1: 245.31483820486133,
    x2: 620.4532001224418,
    y2: 227.86106471845414,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 588.6232989534806,
    y1: 232.40500698027552,
    x2: 600.4438903371107,
    y2: 213.85039517239204,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.1311422146388,
    y1: 221.15120504001882,
    x2: 579.2896117058095,
    y2: 201.63696671009797,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 548.7323255501932,
    y1: 211.639080612088,
    x2: 557.1513610622252,
    y2: 191.31373089683973,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 527.5820962721025,
    y1: 203.94102670695747,
    x2: 534.1976238611965,
    y2: 182.95925379049652,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 505.84142039603057,
    y1: 198.1156301630572,
    x2: 510.60309190266884,
    y2: 176.63711800641863,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 483.6757575927733,
    y1: 194.20722576555693,
    x2: 486.5473338216145,
    y2: 172.39543881533308,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.2538019402567,
    y1: 192.24555883188071,
    x2: 462.21342846229413,
    y2: 170.26649795707982,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.74619805974334,
    y1: 192.24555883188071,
    x2: 437.7865715377059,
    y2: 170.26649795707982,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.32424240722673,
    y1: 194.2072257655569,
    x2: 413.4526661783856,
    y2: 172.39543881533308,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 394.1585796039695,
    y1: 198.1156301630572,
    x2: 389.3969080973312,
    y2: 176.63711800641863,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.41790372789757,
    y1: 203.94102670695744,
    x2: 365.80237613880354,
    y2: 182.95925379049646,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.26767444980686,
    y1: 211.639080612088,
    x2: 342.84863893777487,
    y2: 191.31373089683973,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.8688577853613,
    y1: 221.15120504001877,
    x2: 320.7103882941905,
    y2: 201.63696671009788,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311.37670104651954,
    y1: 232.40500698027546,
    x2: 299.5561096628894,
    y2: 213.85039517239196,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.93955131575007,
    y1: 245.31483820486133,
    x2: 279.5467998775582,
    y2: 227.86106471845414,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 275.69772643515967,
    y1: 259.782447102988,
    x2: 260.8347418676151,
    y2: 243.56234569316527,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.78244710298804,
    y1: 275.69772643515967,
    x2: 243.5623456931653,
    y2: 260.8347418676151,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.3148382048613,
    y1: 292.9395513157501,
    x2: 227.86106471845412,
    y2: 279.54679987755827,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.4050069802755,
    y1: 311.37670104651943,
    x2: 213.85039517239198,
    y2: 299.55610966288936,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.1512050400188,
    y1: 330.86885778536123,
    x2: 201.6369667100979,
    y2: 320.71038829419047,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.639080612088,
    y1: 351.2676744498068,
    x2: 191.31373089683973,
    y2: 342.8486389377748,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.94102670695747,
    y1: 372.4179037278975,
    x2: 182.95925379049652,
    y2: 365.8023761388035,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.11563016305723,
    y1: 394.1585796039694,
    x2: 176.6371180064187,
    y2: 389.3969080973311,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.20722576555693,
    y1: 416.3242424072267,
    x2: 172.39543881533308,
    y2: 413.4526661783856,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.24555883188071,
    y1: 438.7461980597433,
    x2: 170.26649795707982,
    y2: 437.7865715377059,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.24555883188071,
    y1: 461.2538019402568,
    x2: 170.26649795707982,
    y2: 462.21342846229413,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.2072257655569,
    y1: 483.67575759277327,
    x2: 172.39543881533308,
    y2: 486.54733382161436,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.1156301630572,
    y1: 505.84142039603057,
    x2: 176.63711800641863,
    y2: 510.60309190266884,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.94102670695744,
    y1: 527.5820962721025,
    x2: 182.95925379049646,
    y2: 534.1976238611965,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.63908061208795,
    y1: 548.7323255501931,
    x2: 191.31373089683967,
    y2: 557.151361062225,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.15120504001877,
    y1: 569.1311422146387,
    x2: 201.63696671009788,
    y2: 579.2896117058094,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.40500698027546,
    y1: 588.6232989534805,
    x2: 213.85039517239196,
    y2: 600.4438903371106,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.31483820486133,
    y1: 607.0604486842499,
    x2: 227.86106471845414,
    y2: 620.4532001224418,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.78244710298793,
    y1: 624.3022735648402,
    x2: 243.56234569316516,
    y2: 639.1652581323847,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 275.69772643515967,
    y1: 640.217552897012,
    x2: 260.8347418676151,
    y2: 656.4376543068347,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.93955131575,
    y1: 654.6851617951386,
    x2: 279.54679987755816,
    y2: 672.1389352815459,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311.3767010465193,
    y1: 667.5949930197245,
    x2: 299.5561096628892,
    y2: 686.149604827608,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.8688577853611,
    y1: 678.8487949599812,
    x2: 320.71038829419035,
    y2: 698.363033289902,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.2676744498069,
    y1: 688.360919387912,
    x2: 342.8486389377749,
    y2: 708.6862691031604,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.4179037278974,
    y1: 696.0589732930425,
    x2: 365.8023761388033,
    y2: 717.0407462095035,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 394.1585796039695,
    y1: 701.8843698369428,
    x2: 389.3969080973312,
    y2: 723.3628819935814,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.3242424072267,
    y1: 705.7927742344431,
    x2: 413.4526661783855,
    y2: 727.6045611846669,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.7461980597433,
    y1: 707.7544411681192,
    x2: 437.78657153770587,
    y2: 729.7335020429202,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.2538019402567,
    y1: 707.7544411681192,
    x2: 462.21342846229413,
    y2: 729.7335020429202,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 483.6757575927733,
    y1: 705.7927742344431,
    x2: 486.5473338216145,
    y2: 727.6045611846669,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 505.84142039603057,
    y1: 701.8843698369428,
    x2: 510.60309190266884,
    y2: 723.3628819935814,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 527.5820962721025,
    y1: 696.0589732930425,
    x2: 534.1976238611965,
    y2: 717.0407462095035,
    stroke: "black",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 548.7323255501932,
    y1: 688.360919387912,
    x2: 557.1513610622252,
    y2: 708.6862691031603,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 688.360919387912,
    y1: 548.7323255501932,
    x2: 708.6862691031603,
    y2: 557.1513610622251,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 688.360919387912,
    y1: 351.2676744498068,
    x2: 708.6862691031603,
    y2: 342.84863893777487,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 548.7323255501932,
    y1: 211.639080612088,
    x2: 557.1513610622252,
    y2: 191.31373089683973,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.26767444980686,
    y1: 211.639080612088,
    x2: 342.84863893777487,
    y2: 191.31373089683973,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.639080612088,
    y1: 351.2676744498068,
    x2: 191.31373089683973,
    y2: 342.8486389377748,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.63908061208795,
    y1: 548.7323255501931,
    x2: 191.31373089683967,
    y2: 557.151361062225,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.2676744498069,
    y1: 688.360919387912,
    x2: 342.8486389377749,
    y2: 708.6862691031604,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("text", {
    x: 357.84609258233166,
    y: 703.1907797445551,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-340, 357.84609258233166, 703.1907797445551)"
  }, "\u4E59"), /*#__PURE__*/React.createElement("text", {
    x: 403.2122350094223,
    y: 715.3466009716094,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-350, 403.2122350094223, 715.3466009716094)"
  }, "\u58EC"), /*#__PURE__*/React.createElement("text", {
    x: 426.51675667407096,
    y: 718.41469945384,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-355, 426.51675667407096, 718.41469945384)"
  }, "\u5E9A"), /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 719.44,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(0, 450, 719.44)"
  }, "\u620A"), /*#__PURE__*/React.createElement("text", {
    x: 473.48324332592904,
    y: 718.41469945384,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-5, 473.48324332592904, 718.41469945384)"
  }, "\u4E19"), /*#__PURE__*/React.createElement("text", {
    x: 496.7877649905777,
    y: 715.3466009716094,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-10, 496.7877649905777, 715.3466009716094)"
  }, "\u7532"), /*#__PURE__*/React.createElement("text", {
    x: 542.1539074176682,
    y: 703.1907797445551,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-20, 542.1539074176682, 703.1907797445551)"
  }, "\u7678"), /*#__PURE__*/React.createElement("text", {
    x: 563.870264443414,
    y: 694.1955701391549,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-25, 563.870264443414, 694.1955701391549)"
  }, "\u8F9B"), /*#__PURE__*/React.createElement("text", {
    x: 584.72,
    y: 683.3418847956791,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-30, 584.72, 683.3418847956791)"
  }, "\u5DF3"), /*#__PURE__*/React.createElement("text", {
    x: 604.5444350104258,
    y: 670.7123268132259,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-35, 604.5444350104258, 670.7123268132259)"
  }, "\u4E01"), /*#__PURE__*/React.createElement("text", {
    x: 623.1926935539411,
    y: 656.4030147539775,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-40, 623.1926935539411, 656.4030147539775)"
  }, "\u4E59"), /*#__PURE__*/React.createElement("text", {
    x: 656.4030147539775,
    y: 623.1926935539411,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-50, 656.4030147539775, 623.1926935539411)"
  }, "\u58EC"), /*#__PURE__*/React.createElement("text", {
    x: 670.7123268132259,
    y: 604.5444350104258,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-55, 670.7123268132259, 604.5444350104258)"
  }, "\u5E9A"), /*#__PURE__*/React.createElement("text", {
    x: 683.3418847956791,
    y: 584.72,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-60, 683.3418847956791, 584.72)"
  }, "\u620A"), /*#__PURE__*/React.createElement("text", {
    x: 694.1955701391549,
    y: 563.870264443414,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-65, 694.1955701391549, 563.870264443414)"
  }, "\u4E19"), /*#__PURE__*/React.createElement("text", {
    x: 703.1907797445551,
    y: 542.1539074176682,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-70, 703.1907797445551, 542.1539074176682)"
  }, "\u7532"), /*#__PURE__*/React.createElement("text", {
    x: 715.3466009716094,
    y: 496.7877649905777,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-80, 715.3466009716094, 496.7877649905777)"
  }, "\u8F9B"), /*#__PURE__*/React.createElement("text", {
    x: 718.41469945384,
    y: 473.48324332592904,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-85, 718.41469945384, 473.48324332592904)"
  }, "\u5DF3"), /*#__PURE__*/React.createElement("text", {
    x: 719.44,
    y: 450,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-90, 719.44, 450)"
  }, "\u4E01"), /*#__PURE__*/React.createElement("text", {
    x: 718.41469945384,
    y: 426.51675667407096,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-95, 718.41469945384, 426.51675667407096)"
  }, "\u4E59"), /*#__PURE__*/React.createElement("text", {
    x: 715.3466009716094,
    y: 403.2122350094223,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-100, 715.3466009716094, 403.2122350094223)"
  }, "\u7678"), /*#__PURE__*/React.createElement("text", {
    x: 703.1907797445551,
    y: 357.84609258233183,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-110, 703.1907797445551, 357.84609258233183)"
  }, "\u5E9A"), /*#__PURE__*/React.createElement("text", {
    x: 694.1955701391549,
    y: 336.12973555658596,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-115, 694.1955701391549, 336.12973555658596)"
  }, "\u620A"), /*#__PURE__*/React.createElement("text", {
    x: 683.3418847956791,
    y: 315.28000000000003,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-120, 683.3418847956791, 315.28000000000003)"
  }, "\u4E19"), /*#__PURE__*/React.createElement("text", {
    x: 670.7123268132259,
    y: 295.45556498957416,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-125, 670.7123268132259, 295.45556498957416)"
  }, "\u7532"), /*#__PURE__*/React.createElement("text", {
    x: 656.4030147539775,
    y: 276.8073064460589,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-130, 656.4030147539775, 276.8073064460589)"
  }, "\u58EC"), /*#__PURE__*/React.createElement("text", {
    x: 623.1926935539411,
    y: 243.59698524602257,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-140, 623.1926935539411, 243.59698524602257)"
  }, "\u5DF3"), /*#__PURE__*/React.createElement("text", {
    x: 604.5444350104258,
    y: 229.28767318677404,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-145, 604.5444350104258, 229.28767318677404)"
  }, "\u4E01"), /*#__PURE__*/React.createElement("text", {
    x: 584.72,
    y: 216.65811520432086,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-150, 584.72, 216.65811520432086)"
  }, "\u4E59"), /*#__PURE__*/React.createElement("text", {
    x: 563.870264443414,
    y: 205.80442986084503,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-155, 563.870264443414, 205.80442986084503)"
  }, "\u7678"), /*#__PURE__*/React.createElement("text", {
    x: 542.1539074176682,
    y: 196.80922025544487,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-160, 542.1539074176682, 196.80922025544487)"
  }, "\u8F9B"), /*#__PURE__*/React.createElement("text", {
    x: 496.7877649905777,
    y: 184.65339902839065,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-170, 496.7877649905777, 184.65339902839065)"
  }, "\u620A"), /*#__PURE__*/React.createElement("text", {
    x: 473.48324332592904,
    y: 181.58530054616006,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-175, 473.48324332592904, 181.58530054616006)"
  }, "\u4E19"), /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 180.56,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-180, 450, 180.56)"
  }, "\u7532"), /*#__PURE__*/React.createElement("text", {
    x: 426.51675667407096,
    y: 181.58530054616006,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-185, 426.51675667407096, 181.58530054616006)"
  }, "\u58EC"), /*#__PURE__*/React.createElement("text", {
    x: 403.21223500942233,
    y: 184.65339902839065,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-190, 403.21223500942233, 184.65339902839065)"
  }, "\u5E9A"), /*#__PURE__*/React.createElement("text", {
    x: 357.84609258233183,
    y: 196.80922025544484,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-200, 357.84609258233183, 196.80922025544484)"
  }, "\u4E01"), /*#__PURE__*/React.createElement("text", {
    x: 336.12973555658596,
    y: 205.804429860845,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-205, 336.12973555658596, 205.804429860845)"
  }, "\u4E59"), /*#__PURE__*/React.createElement("text", {
    x: 315.2800000000001,
    y: 216.65811520432084,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-210, 315.2800000000001, 216.65811520432084)"
  }, "\u7678"), /*#__PURE__*/React.createElement("text", {
    x: 295.4555649895742,
    y: 229.287673186774,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-215, 295.4555649895742, 229.287673186774)"
  }, "\u8F9B"), /*#__PURE__*/React.createElement("text", {
    x: 276.8073064460589,
    y: 243.59698524602257,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-220, 276.8073064460589, 243.59698524602257)"
  }, "\u5DF3"), /*#__PURE__*/React.createElement("text", {
    x: 243.5969852460226,
    y: 276.8073064460588,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-230, 243.5969852460226, 276.8073064460588)"
  }, "\u4E19"), /*#__PURE__*/React.createElement("text", {
    x: 229.2876731867741,
    y: 295.4555649895741,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-235, 229.2876731867741, 295.4555649895741)"
  }, "\u7532"), /*#__PURE__*/React.createElement("text", {
    x: 216.65811520432084,
    y: 315.28000000000003,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-240, 216.65811520432084, 315.28000000000003)"
  }, "\u58EC"), /*#__PURE__*/React.createElement("text", {
    x: 205.80442986084503,
    y: 336.12973555658596,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-245, 205.80442986084503, 336.12973555658596)"
  }, "\u5E9A"), /*#__PURE__*/React.createElement("text", {
    x: 196.80922025544487,
    y: 357.8460925823318,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-250, 196.80922025544487, 357.8460925823318)"
  }, "\u620A"), /*#__PURE__*/React.createElement("text", {
    x: 184.65339902839065,
    y: 403.21223500942233,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-260, 184.65339902839065, 403.21223500942233)"
  }, "\u4E59"), /*#__PURE__*/React.createElement("text", {
    x: 181.58530054616006,
    y: 426.51675667407085,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-265, 181.58530054616006, 426.51675667407085)"
  }, "\u7678"), /*#__PURE__*/React.createElement("text", {
    x: 180.56,
    y: 449.99999999999994,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-270, 180.56, 449.99999999999994)"
  }, "\u8F9B"), /*#__PURE__*/React.createElement("text", {
    x: 181.58530054616006,
    y: 473.483243325929,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-275, 181.58530054616006, 473.483243325929)"
  }, "\u5DF3"), /*#__PURE__*/React.createElement("text", {
    x: 184.65339902839065,
    y: 496.7877649905777,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-280, 184.65339902839065, 496.7877649905777)"
  }, "\u4E01"), /*#__PURE__*/React.createElement("text", {
    x: 196.80922025544484,
    y: 542.1539074176682,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-290, 196.80922025544484, 542.1539074176682)"
  }, "\u7532"), /*#__PURE__*/React.createElement("text", {
    x: 205.804429860845,
    y: 563.870264443414,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-295, 205.804429860845, 563.870264443414)"
  }, "\u58EC"), /*#__PURE__*/React.createElement("text", {
    x: 216.65811520432086,
    y: 584.72,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-300, 216.65811520432086, 584.72)"
  }, "\u5E9A"), /*#__PURE__*/React.createElement("text", {
    x: 229.287673186774,
    y: 604.5444350104258,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-305, 229.287673186774, 604.5444350104258)"
  }, "\u620A"), /*#__PURE__*/React.createElement("text", {
    x: 243.59698524602254,
    y: 623.1926935539411,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-310, 243.59698524602254, 623.1926935539411)"
  }, "\u4E19"), /*#__PURE__*/React.createElement("text", {
    x: 276.8073064460588,
    y: 656.4030147539775,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-320, 276.8073064460588, 656.4030147539775)"
  }, "\u7678"), /*#__PURE__*/React.createElement("text", {
    x: 295.4555649895741,
    y: 670.7123268132259,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-325, 295.4555649895741, 670.7123268132259)"
  }, "\u8F9B"), /*#__PURE__*/React.createElement("text", {
    x: 315.27999999999986,
    y: 683.3418847956791,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-330, 315.27999999999986, 683.3418847956791)"
  }, "\u5DF3"), /*#__PURE__*/React.createElement("text", {
    x: 336.12973555658584,
    y: 694.1955701391549,
    fontSize: 9,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-335, 336.12973555658584, 694.1955701391549)"
  }, "\u4E01"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "inner-ring-3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 258,
    fill: "none",
    stroke: "black",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 236,
    fill: "none",
    stroke: "black",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540.3132900381612,
    y1: 668.0355696726637,
    x2: 548.7323255501932,
    y2: 688.360919387912,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 593.6676972460581,
    y1: 637.2313883087315,
    x2: 607.0604486842499,
    y2: 654.6851617951387,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 637.2313883087315,
    y1: 593.6676972460581,
    x2: 654.6851617951387,
    y2: 607.0604486842499,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 668.0355696726637,
    y1: 540.3132900381612,
    x2: 688.360919387912,
    y2: 548.7323255501932,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 683.9809872842193,
    y1: 480.8041813639322,
    x2: 705.7927742344431,
    y2: 483.6757575927733,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 683.9809872842193,
    y1: 419.1958186360678,
    x2: 705.7927742344431,
    y2: 416.3242424072267,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 668.0355696726637,
    y1: 359.6867099618388,
    x2: 688.360919387912,
    y2: 351.2676744498068,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 637.2313883087315,
    y1: 306.3323027539419,
    x2: 654.6851617951387,
    y2: 292.93955131575007,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 593.6676972460581,
    y1: 262.76861169126846,
    x2: 607.0604486842499,
    y2: 245.31483820486133,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540.3132900381612,
    y1: 231.96443032733632,
    x2: 548.7323255501932,
    y2: 211.639080612088,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.80418136393223,
    y1: 216.01901271578075,
    x2: 483.6757575927733,
    y2: 194.20722576555693,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 419.1958186360679,
    y1: 216.01901271578072,
    x2: 416.32424240722673,
    y2: 194.2072257655569,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 359.6867099618388,
    y1: 231.96443032733632,
    x2: 351.26767444980686,
    y2: 211.639080612088,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.3323027539419,
    y1: 262.76861169126846,
    x2: 292.93955131575007,
    y2: 245.31483820486133,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 262.76861169126846,
    y1: 306.332302753942,
    x2: 245.3148382048613,
    y2: 292.9395513157501,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.96443032733632,
    y1: 359.6867099618388,
    x2: 211.639080612088,
    y2: 351.2676744498068,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.01901271578075,
    y1: 419.1958186360678,
    x2: 194.20722576555693,
    y2: 416.3242424072267,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.01901271578072,
    y1: 480.8041813639321,
    x2: 194.2072257655569,
    y2: 483.67575759277327,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.9644303273363,
    y1: 540.3132900381611,
    x2: 211.63908061208795,
    y2: 548.7323255501931,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 262.76861169126846,
    y1: 593.6676972460581,
    x2: 245.31483820486133,
    y2: 607.0604486842499,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.33230275394186,
    y1: 637.2313883087314,
    x2: 292.93955131575,
    y2: 654.6851617951386,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 359.68670996183886,
    y1: 668.0355696726637,
    x2: 351.2676744498069,
    y2: 688.360919387912,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 419.1958186360678,
    y1: 683.9809872842193,
    x2: 416.3242424072267,
    y2: 705.7927742344431,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.80418136393223,
    y1: 683.9809872842193,
    x2: 483.6757575927733,
    y2: 705.7927742344431,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540.3132900381612,
    y1: 668.0355696726637,
    x2: 548.7323255501932,
    y2: 688.360919387912,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 668.0355696726637,
    y1: 540.3132900381612,
    x2: 688.360919387912,
    y2: 548.7323255501932,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 668.0355696726637,
    y1: 359.6867099618388,
    x2: 688.360919387912,
    y2: 351.2676744498068,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540.3132900381612,
    y1: 231.96443032733632,
    x2: 548.7323255501932,
    y2: 211.639080612088,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 359.6867099618388,
    y1: 231.96443032733632,
    x2: 351.26767444980686,
    y2: 211.639080612088,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.96443032733632,
    y1: 359.6867099618388,
    x2: 211.639080612088,
    y2: 351.2676744498068,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.9644303273363,
    y1: 540.3132900381611,
    x2: 211.63908061208795,
    y2: 548.7323255501931,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 359.68670996183886,
    y1: 668.0355696726637,
    x2: 351.2676744498069,
    y2: 688.360919387912,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("text", {
    x: 385.9578154798323,
    y: 689.0086864569671,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-345, 385.9578154798323, 689.0086864569671)"
  }, "\u7678"), /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 697.44,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(0, 450, 697.44)"
  }, "\u5B50"), /*#__PURE__*/React.createElement("text", {
    x: 514.0421845201678,
    y: 689.0086864569671,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-15, 514.0421845201678, 689.0086864569671)"
  }, "\u58EC"), /*#__PURE__*/React.createElement("text", {
    x: 573.72,
    y: 664.2893259124214,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-30, 573.72, 664.2893259124214)"
  }, "\u4EA5"), /*#__PURE__*/React.createElement("text", {
    x: 624.9665019367993,
    y: 624.9665019367993,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-45, 624.9665019367993, 624.9665019367993)"
  }, "\u4E7E"), /*#__PURE__*/React.createElement("text", {
    x: 664.2893259124215,
    y: 573.72,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-60, 664.2893259124215, 573.72)"
  }, "\u620C"), /*#__PURE__*/React.createElement("text", {
    x: 689.0086864569671,
    y: 514.0421845201678,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-75, 689.0086864569671, 514.0421845201678)"
  }, "\u8F9B"), /*#__PURE__*/React.createElement("text", {
    x: 697.44,
    y: 450,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-90, 697.44, 450)"
  }, "\u9149"), /*#__PURE__*/React.createElement("text", {
    x: 689.0086864569671,
    y: 385.9578154798323,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-105, 689.0086864569671, 385.9578154798323)"
  }, "\u5E9A"), /*#__PURE__*/React.createElement("text", {
    x: 664.2893259124215,
    y: 326.28000000000003,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-120, 664.2893259124215, 326.28000000000003)"
  }, "\u7533"), /*#__PURE__*/React.createElement("text", {
    x: 624.9665019367993,
    y: 275.0334980632007,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-135, 624.9665019367993, 275.0334980632007)"
  }, "\u5764"), /*#__PURE__*/React.createElement("text", {
    x: 573.72,
    y: 235.71067408757852,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-150, 573.72, 235.71067408757852)"
  }, "\u672A"), /*#__PURE__*/React.createElement("text", {
    x: 514.0421845201678,
    y: 210.99131354303293,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-165, 514.0421845201678, 210.99131354303293)"
  }, "\u4E01"), /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 202.56,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-180, 450, 202.56)"
  }, "\u5348"), /*#__PURE__*/React.createElement("text", {
    x: 385.9578154798322,
    y: 210.99131354303293,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-195, 385.9578154798322, 210.99131354303293)"
  }, "\u4E19"), /*#__PURE__*/React.createElement("text", {
    x: 326.2800000000001,
    y: 235.7106740875785,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-210, 326.2800000000001, 235.7106740875785)"
  }, "\u5DF3"), /*#__PURE__*/React.createElement("text", {
    x: 275.0334980632007,
    y: 275.0334980632007,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-225, 275.0334980632007, 275.0334980632007)"
  }, "\u5DFD"), /*#__PURE__*/React.createElement("text", {
    x: 235.7106740875785,
    y: 326.28000000000003,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-240, 235.7106740875785, 326.28000000000003)"
  }, "\u8FB0"), /*#__PURE__*/React.createElement("text", {
    x: 210.99131354303296,
    y: 385.9578154798322,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-255, 210.99131354303296, 385.9578154798322)"
  }, "\u4E59"), /*#__PURE__*/React.createElement("text", {
    x: 202.56,
    y: 449.99999999999994,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-270, 202.56, 449.99999999999994)"
  }, "\u536F"), /*#__PURE__*/React.createElement("text", {
    x: 210.9913135430329,
    y: 514.0421845201677,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-285, 210.9913135430329, 514.0421845201677)"
  }, "\u7533"), /*#__PURE__*/React.createElement("text", {
    x: 235.71067408757852,
    y: 573.72,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-300, 235.71067408757852, 573.72)"
  }, "\u5BC5"), /*#__PURE__*/React.createElement("text", {
    x: 275.0334980632007,
    y: 624.9665019367993,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-315, 275.0334980632007, 624.9665019367993)"
  }, "\u826E"), /*#__PURE__*/React.createElement("text", {
    x: 326.27999999999986,
    y: 664.2893259124214,
    fontSize: 13,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-330, 326.27999999999986, 664.2893259124214)"
  }, "\u4E11"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "inner-ring-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 236,
    fill: "none",
    stroke: "black",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 214,
    fill: "none",
    stroke: "black",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 531.8942545261292,
    y1: 647.7102199574153,
    x2: 540.3132900381612,
    y2: 668.0355696726637,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580.2749458078663,
    y1: 619.7776148223243,
    x2: 593.6676972460581,
    y2: 637.2313883087315,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 619.7776148223243,
    y1: 580.2749458078663,
    x2: 637.2313883087315,
    y2: 593.6676972460581,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.7102199574153,
    y1: 531.8942545261292,
    x2: 668.0355696726637,
    y2: 540.3132900381612,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 662.1692003339954,
    y1: 477.932605135091,
    x2: 683.9809872842193,
    y2: 480.8041813639322,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 662.1692003339954,
    y1: 422.067394864909,
    x2: 683.9809872842193,
    y2: 419.1958186360678,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.7102199574153,
    y1: 368.1057454738708,
    x2: 668.0355696726637,
    y2: 359.6867099618388,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 619.7776148223243,
    y1: 319.72505419213377,
    x2: 637.2313883087315,
    y2: 306.3323027539419,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580.2749458078663,
    y1: 280.2223851776757,
    x2: 593.6676972460581,
    y2: 262.76861169126846,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 531.8942545261292,
    y1: 252.28978004258462,
    x2: 540.3132900381612,
    y2: 231.96443032733632,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 477.9326051350911,
    y1: 237.83079966600457,
    x2: 480.80418136393223,
    y2: 216.01901271578075,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.06739486490903,
    y1: 237.83079966600457,
    x2: 419.1958186360679,
    y2: 216.01901271578072,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.1057454738708,
    y1: 252.28978004258462,
    x2: 359.6867099618388,
    y2: 231.96443032733632,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 319.72505419213377,
    y1: 280.2223851776757,
    x2: 306.3323027539419,
    y2: 262.76861169126846,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.2223851776756,
    y1: 319.7250541921338,
    x2: 262.76861169126846,
    y2: 306.332302753942,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.28978004258462,
    y1: 368.1057454738708,
    x2: 231.96443032733632,
    y2: 359.6867099618388,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.83079966600457,
    y1: 422.067394864909,
    x2: 216.01901271578075,
    y2: 419.1958186360678,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.83079966600457,
    y1: 477.93260513509097,
    x2: 216.01901271578072,
    y2: 480.8041813639321,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.2897800425846,
    y1: 531.8942545261291,
    x2: 231.9644303273363,
    y2: 540.3132900381611,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.2223851776757,
    y1: 580.2749458078663,
    x2: 262.76861169126846,
    y2: 593.6676972460581,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 319.7250541921337,
    y1: 619.7776148223243,
    x2: 306.33230275394186,
    y2: 637.2313883087314,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.10574547387085,
    y1: 647.7102199574153,
    x2: 359.68670996183886,
    y2: 668.0355696726637,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.067394864909,
    y1: 662.1692003339954,
    x2: 419.1958186360678,
    y2: 683.9809872842193,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 477.9326051350911,
    y1: 662.1692003339954,
    x2: 480.80418136393223,
    y2: 683.9809872842193,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 531.8942545261292,
    y1: 647.7102199574153,
    x2: 540.3132900381612,
    y2: 668.0355696726637,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.7102199574153,
    y1: 531.8942545261292,
    x2: 668.0355696726637,
    y2: 540.3132900381612,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.7102199574153,
    y1: 368.1057454738708,
    x2: 668.0355696726637,
    y2: 359.6867099618388,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 531.8942545261292,
    y1: 252.28978004258462,
    x2: 540.3132900381612,
    y2: 231.96443032733632,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.1057454738708,
    y1: 252.28978004258462,
    x2: 359.6867099618388,
    y2: 231.96443032733632,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.28978004258462,
    y1: 368.1057454738708,
    x2: 231.96443032733632,
    y2: 359.6867099618388,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.2897800425846,
    y1: 531.8942545261291,
    x2: 231.9644303273363,
    y2: 540.3132900381611,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.10574547387085,
    y1: 647.7102199574153,
    x2: 359.68670996183886,
    y2: 668.0355696726637,
    stroke: "black",
    strokeWidth: 1.45
  }), /*#__PURE__*/React.createElement("text", {
    x: 391.6518344720877,
    y: 667.7583182786076,
    fontSize: 12,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-345, 391.6518344720877, 667.7583182786076)"
  }, "\u826E"), /*#__PURE__*/React.createElement("text", {
    x: 508.3481655279123,
    y: 667.7583182786076,
    fontSize: 12,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-15, 508.3481655279123, 667.7583182786076)"
  }, "\u4E7E"), /*#__PURE__*/React.createElement("text", {
    x: 609.4101527506953,
    y: 609.4101527506953,
    fontSize: 12,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-45, 609.4101527506953, 609.4101527506953)"
  }, "\u58EC\u8F9B"), /*#__PURE__*/React.createElement("text", {
    x: 667.7583182786076,
    y: 508.3481655279123,
    fontSize: 12,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-75, 667.7583182786076, 508.3481655279123)"
  }, "\u4E7E"), /*#__PURE__*/React.createElement("text", {
    x: 667.7583182786076,
    y: 391.6518344720877,
    fontSize: 12,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-105, 667.7583182786076, 391.6518344720877)"
  }, "\u5764"), /*#__PURE__*/React.createElement("text", {
    x: 609.4101527506953,
    y: 290.58984724930474,
    fontSize: 12,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-135, 609.4101527506953, 290.58984724930474)"
  }, "\u4E01\u5E9A"), /*#__PURE__*/React.createElement("text", {
    x: 508.3481655279123,
    y: 232.24168172139244,
    fontSize: 12,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-165, 508.3481655279123, 232.24168172139244)"
  }, "\u5764"), /*#__PURE__*/React.createElement("text", {
    x: 391.65183447208767,
    y: 232.24168172139244,
    fontSize: 12,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-195, 391.65183447208767, 232.24168172139244)"
  }, "\u5DFD"), /*#__PURE__*/React.createElement("text", {
    x: 290.58984724930474,
    y: 290.58984724930474,
    fontSize: 12,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-225, 290.58984724930474, 290.58984724930474)"
  }, "\u4E19\u4E59"), /*#__PURE__*/React.createElement("text", {
    x: 232.24168172139247,
    y: 391.65183447208767,
    fontSize: 12,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-255, 232.24168172139247, 391.65183447208767)"
  }, "\u5DFD"), /*#__PURE__*/React.createElement("text", {
    x: 232.2416817213924,
    y: 508.3481655279122,
    fontSize: 12,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-285, 232.2416817213924, 508.3481655279122)"
  }, "\u826E"), /*#__PURE__*/React.createElement("text", {
    x: 290.5898472493047,
    y: 609.4101527506953,
    fontSize: 12,
    fontWeight: "normal",
    fontFamily: "\\u6977\\u4F53, KaiTi, STKaiti, Kaiti SC, serif",
    fill: "black",
    textAnchor: "middle",
    dominantBaseline: "middle",
    transform: "rotate(-315, 290.5898472493047, 609.4101527506953)"
  }, "\u7678\u7532"))), /*#__PURE__*/React.createElement("g", {
    id: "inner-ring-1"
  }, _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 523.4752190140972,
    y1: 627.384870242167,
    x2: 531.8942545261292,
    y2: 647.7102199574153,
    stroke: "black",
    strokeWidth: 1.2
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 627.384870242167,
    y1: 523.4752190140972,
    x2: 647.7102199574153,
    y2: 531.8942545261292,
    stroke: "black",
    strokeWidth: 1.2
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 627.384870242167,
    y1: 376.5247809859028,
    x2: 647.7102199574153,
    y2: 368.1057454738708,
    stroke: "black",
    strokeWidth: 1.2
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 523.4752190140972,
    y1: 272.61512975783296,
    x2: 531.8942545261292,
    y2: 252.28978004258462,
    stroke: "black",
    strokeWidth: 1.2
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 376.5247809859028,
    y1: 272.61512975783296,
    x2: 368.1057454738708,
    y2: 252.28978004258462,
    stroke: "black",
    strokeWidth: 1.2
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 272.61512975783296,
    y1: 376.52478098590274,
    x2: 252.28978004258462,
    y2: 368.1057454738708,
    stroke: "black",
    strokeWidth: 1.2
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 272.6151297578329,
    y1: 523.4752190140971,
    x2: 252.2897800425846,
    y2: 531.8942545261291,
    stroke: "black",
    strokeWidth: 1.2
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 376.5247809859028,
    y1: 627.384870242167,
    x2: 368.10574547387085,
    y2: 647.7102199574153,
    stroke: "black",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(450,653.44) rotate(0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    x: -11.5,
    y: -6.388888888888889,
    width: 23,
    height: 12.777777777777779,
    viewBox: "0 0 9 5",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 4,
    y2: 0.5,
    stroke: "black"
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 0.5,
    x2: 9,
    y2: 0.5,
    stroke: "black"
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    y1: 4.5,
    x2: 4,
    y2: 4.5,
    stroke: "black"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 4.5,
    x2: 9,
    y2: 4.5,
    stroke: "black"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    y1: 2.5,
    x2: 9,
    y2: 2.5,
    stroke: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(306.14619643540874,593.8538035645912) rotate(-315)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    x: -11.5,
    y: -6.388888888888889,
    width: 23,
    height: 12.777777777777779,
    viewBox: "0 0 9 5",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    y1: 4.5,
    x2: 4,
    y2: 4.5,
    stroke: "black"
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 4.5,
    x2: 9,
    y2: 4.5,
    stroke: "black"
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    y1: 2.5,
    x2: 4,
    y2: 2.5,
    stroke: "black"
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 2.5,
    x2: 9,
    y2: 2.5,
    stroke: "black"
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 9,
    y2: 0.5,
    stroke: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(246.56,450) rotate(-270)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    x: -11.5,
    y: -6.388888888888889,
    width: 23,
    height: 12.777777777777779,
    viewBox: "0 0 9 5",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    y1: 4.5,
    x2: 9,
    y2: 4.5,
    stroke: "black"
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 4,
    y2: 0.5,
    stroke: "black"
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 0.5,
    x2: 9,
    y2: 0.5,
    stroke: "black"
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    y1: 4.5,
    x2: 9,
    y2: 4.5,
    stroke: "black"
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    y1: 2.5,
    x2: 4,
    y2: 2.5,
    stroke: "black"
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 2.5,
    x2: 9,
    y2: 2.5,
    stroke: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(306.1461964354088,306.1461964354088) rotate(-225)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    x: -11.5,
    y: -6.388888888888889,
    width: 23,
    height: 12.777777777777779,
    viewBox: "0 0 9 5",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    y1: 4.5,
    x2: 4,
    y2: 4.5,
    stroke: "black"
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 4.5,
    x2: 9,
    y2: 4.5,
    stroke: "black"
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    y1: 2.5,
    x2: 9,
    y2: 2.5,
    stroke: "black"
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 9,
    y2: 0.5,
    stroke: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(450,246.56) rotate(-180)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    x: -11.5,
    y: -6.388888888888889,
    width: 23,
    height: 12.777777777777779,
    viewBox: "0 0 9 5",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    y1: 2.5,
    x2: 4,
    y2: 2.5,
    stroke: "black"
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 2.5,
    x2: 9,
    y2: 2.5,
    stroke: "black"
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 9,
    y2: 0.5,
    stroke: "black"
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    y1: 4.5,
    x2: 9,
    y2: 4.5,
    stroke: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(593.8538035645912,306.1461964354088) rotate(-135)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    x: -11.5,
    y: -6.388888888888889,
    width: 23,
    height: 12.777777777777779,
    viewBox: "0 0 9 5",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 4,
    y2: 0.5,
    stroke: "black"
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 0.5,
    x2: 9,
    y2: 0.5,
    stroke: "black"
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    y1: 4.5,
    x2: 4,
    y2: 4.5,
    stroke: "black"
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 4.5,
    x2: 9,
    y2: 4.5,
    stroke: "black"
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    y1: 2.5,
    x2: 4,
    y2: 2.5,
    stroke: "black"
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 2.5,
    x2: 9,
    y2: 2.5,
    stroke: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(653.44,450) rotate(-90)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    x: -11.5,
    y: -6.388888888888889,
    width: 23,
    height: 12.777777777777779,
    viewBox: "0 0 9 5",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    y1: 2.5,
    x2: 9,
    y2: 2.5,
    stroke: "black"
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    y1: 4.5,
    x2: 9,
    y2: 4.5,
    stroke: "black"
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 4,
    y2: 0.5,
    stroke: "black"
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 0.5,
    x2: 9,
    y2: 0.5,
    stroke: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(593.8538035645912,593.8538035645912) rotate(-45)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    x: -11.5,
    y: -6.388888888888889,
    width: 23,
    height: 12.777777777777779,
    viewBox: "0 0 9 5",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 9,
    y2: 0.5,
    stroke: "black"
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    y1: 2.5,
    x2: 9,
    y2: 2.5,
    stroke: "black"
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    y1: 4.5,
    x2: 9,
    y2: 4.5,
    stroke: "black"
  })))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 450,
    r: 192,
    fill: "none",
    stroke: "black",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFengshuiCompass);
export default __webpack_public_path__ + "static/media/fengshui-compass.bff4228ad9b24cb8ce27ef2797be4320.svg";
export { ForwardRef as ReactComponent };